var items = {
  "block.minecraft.acacia_button": "Akaatsianupp",
  "block.minecraft.acacia_door": "Akaatsiast uks",
  "block.minecraft.acacia_fence": "Akaatsiast aed",
  "block.minecraft.acacia_fence_gate": "Akaatsiast aiavärav",
  "block.minecraft.acacia_hanging_sign": "Akaatsiast rippuv silt",
  "block.minecraft.acacia_leaves": "Akaatsialehed",
  "block.minecraft.acacia_log": "Akaatsiapalk",
  "block.minecraft.acacia_planks": "Akaatsialauad",
  "block.minecraft.acacia_pressure_plate": "Akaatsiast surveplaat",
  "block.minecraft.acacia_sapling": "Akaatsiaistik",
  "block.minecraft.acacia_shelf": "Akaatsiast riiul",
  "block.minecraft.acacia_sign": "Akaatsiast silt",
  "block.minecraft.acacia_slab": "Akaatsiaplaat",
  "block.minecraft.acacia_stairs": "Akaatsiatrepp",
  "block.minecraft.acacia_trapdoor": "Akaatsialuuk",
  "block.minecraft.acacia_wall_hanging_sign": "Akaatsiast seinal rippuv silt",
  "block.minecraft.acacia_wall_sign": "Akaatsiast seinasilt",
  "block.minecraft.acacia_wood": "Akaatsiapuit",
  "block.minecraft.activator_rail": "Käivitusrööpad",
  "block.minecraft.air": "Õhk",
  "block.minecraft.allium": "Lauk",
  "block.minecraft.amethyst_block": "Ametüstiplokk",
  "block.minecraft.amethyst_cluster": "Ametüstikobar",
  "block.minecraft.ancient_debris": "Antiikrusud",
  "block.minecraft.andesite": "Andesiit",
  "block.minecraft.andesite_slab": "Andesiitplaat",
  "block.minecraft.andesite_stairs": "Andesiit-trepp",
  "block.minecraft.andesite_wall": "Andesiitmüür",
  "block.minecraft.anvil": "Alasi",
  "block.minecraft.attached_melon_stem": "Kinnitunud arbuusivars",
  "block.minecraft.attached_pumpkin_stem": "Kinnitunud kõrvitsavars",
  "block.minecraft.azalea": "Asalea",
  "block.minecraft.azalea_leaves": "Asalealehed",
  "block.minecraft.azure_bluet": "Sinine inglisilm",
  "block.minecraft.bamboo": "Bambus",
  "block.minecraft.bamboo_block": "Bambuseplokk",
  "block.minecraft.bamboo_button": "Bambusnupp",
  "block.minecraft.bamboo_door": "Bambusest uks",
  "block.minecraft.bamboo_fence": "Bambusest aed",
  "block.minecraft.bamboo_fence_gate": "Bambusest aiavärav",
  "block.minecraft.bamboo_hanging_sign": "Bambusest rippuv silt",
  "block.minecraft.bamboo_mosaic": "Bambusmosaiik",
  "block.minecraft.bamboo_mosaic_slab": "Bambusmosaiigi plaat",
  "block.minecraft.bamboo_mosaic_stairs": "Bambusmosaiigist trepp",
  "block.minecraft.bamboo_planks": "Bambuslauad",
  "block.minecraft.bamboo_pressure_plate": "Bambusest surveplaat",
  "block.minecraft.bamboo_sapling": "Bambusevõrse",
  "block.minecraft.bamboo_shelf": "Bambusest riiul",
  "block.minecraft.bamboo_sign": "Bambusest silt",
  "block.minecraft.bamboo_slab": "Bambusplaat",
  "block.minecraft.bamboo_stairs": "Bambustrepp",
  "block.minecraft.bamboo_trapdoor": "Bambusluuk",
  "block.minecraft.bamboo_wall_hanging_sign": "Bambusest seinal rippuv silt",
  "block.minecraft.bamboo_wall_sign": "Bambusest seinasilt",
  "block.minecraft.banner.base.black": "Täielikult musta täitega",
  "block.minecraft.banner.base.blue": "Täielikult sinise täitega",
  "block.minecraft.banner.base.brown": "Täielikult pruuni täitega",
  "block.minecraft.banner.base.cyan": "Täielikult tsüaansinise täitega",
  "block.minecraft.banner.base.gray": "Täielikult halli täitega",
  "block.minecraft.banner.base.green": "Täielikult rohelise täitega",
  "block.minecraft.banner.base.light_blue": "Täielikult helesinise täitega",
  "block.minecraft.banner.base.light_gray": "Täielikult helehalli täitega",
  "block.minecraft.banner.base.lime": "Täielikult laimirohelise täitega",
  "block.minecraft.banner.base.magenta": "Täielikult magentapunase täitega",
  "block.minecraft.banner.base.orange": "Täielikult oranži täitega",
  "block.minecraft.banner.base.pink": "Täielikult roosa täitega",
  "block.minecraft.banner.base.purple": "Täielikult lilla täitega",
  "block.minecraft.banner.base.red": "Täielikult punase täitega",
  "block.minecraft.banner.base.white": "Täielikult valge täitega",
  "block.minecraft.banner.base.yellow": "Täielikult kollase täitega",
  "block.minecraft.banner.border.black": "Musta poordiga",
  "block.minecraft.banner.border.blue": "Sinise poordiga",
  "block.minecraft.banner.border.brown": "Pruuni poordiga",
  "block.minecraft.banner.border.cyan": "Tsüaansinise poordiga",
  "block.minecraft.banner.border.gray": "Halli poordiga",
  "block.minecraft.banner.border.green": "Rohelise poordiga",
  "block.minecraft.banner.border.light_blue": "Helesinise poordiga",
  "block.minecraft.banner.border.light_gray": "Helehalli poordiga",
  "block.minecraft.banner.border.lime": "Laimirohelise poordiga",
  "block.minecraft.banner.border.magenta": "Magentapunase poordiga",
  "block.minecraft.banner.border.orange": "Oranži poordiga",
  "block.minecraft.banner.border.pink": "Roosa poordiga",
  "block.minecraft.banner.border.purple": "Lilla poordiga",
  "block.minecraft.banner.border.red": "Punase poordiga",
  "block.minecraft.banner.border.white": "Valge poordiga",
  "block.minecraft.banner.border.yellow": "Kollase poordiga",
  "block.minecraft.banner.bricks.black": "Mustade telliste täitega",
  "block.minecraft.banner.bricks.blue": "Siniste telliste täitega",
  "block.minecraft.banner.bricks.brown": "Pruunide telliste täitega",
  "block.minecraft.banner.bricks.cyan": "Tsüaansiniste telliste täitega",
  "block.minecraft.banner.bricks.gray": "Hallide telliste täitega",
  "block.minecraft.banner.bricks.green": "Roheliste telliste täitega",
  "block.minecraft.banner.bricks.light_blue": "Helesiniste telliste täitega",
  "block.minecraft.banner.bricks.light_gray": "Helehallide telliste täitega",
  "block.minecraft.banner.bricks.lime": "Laimiroheliste telliste täitega",
  "block.minecraft.banner.bricks.magenta": "Magentapunaste telliste täitega",
  "block.minecraft.banner.bricks.orange": "Oranžide telliste täitega",
  "block.minecraft.banner.bricks.pink": "Roosade telliste täitega",
  "block.minecraft.banner.bricks.purple": "Lillade telliste täitega",
  "block.minecraft.banner.bricks.red": "Punaste telliste täitega",
  "block.minecraft.banner.bricks.white": "Valgete telliste täitega",
  "block.minecraft.banner.bricks.yellow": "Kollaste telliste täitega",
  "block.minecraft.banner.circle.black": "Musta sõõriga",
  "block.minecraft.banner.circle.blue": "Sinise sõõriga",
  "block.minecraft.banner.circle.brown": "Pruuni sõõriga",
  "block.minecraft.banner.circle.cyan": "Tsüaansinise sõõriga",
  "block.minecraft.banner.circle.gray": "Halli sõõriga",
  "block.minecraft.banner.circle.green": "Rohelise sõõriga",
  "block.minecraft.banner.circle.light_blue": "Helesinise sõõriga",
  "block.minecraft.banner.circle.light_gray": "Helehalli sõõriga",
  "block.minecraft.banner.circle.lime": "Laimirohelise sõõriga",
  "block.minecraft.banner.circle.magenta": "Magentapunase sõõriga",
  "block.minecraft.banner.circle.orange": "Oranži sõõriga",
  "block.minecraft.banner.circle.pink": "Roosa sõõriga",
  "block.minecraft.banner.circle.purple": "Lilla sõõriga",
  "block.minecraft.banner.circle.red": "Punase sõõriga",
  "block.minecraft.banner.circle.white": "Valge sõõriga",
  "block.minecraft.banner.circle.yellow": "Kollase sõõriga",
  "block.minecraft.banner.creeper.black": "Musta creeperiembleemiga",
  "block.minecraft.banner.creeper.blue": "Sinise creeperiembleemiga",
  "block.minecraft.banner.creeper.brown": "Pruuni creeperiembleemiga",
  "block.minecraft.banner.creeper.cyan": "Tsüaansinise creeperiembleemiga",
  "block.minecraft.banner.creeper.gray": "Halli creeperiembleemiga",
  "block.minecraft.banner.creeper.green": "Rohelise creeperiembleemiga",
  "block.minecraft.banner.creeper.light_blue": "Helesinise creeperiembleemiga",
  "block.minecraft.banner.creeper.light_gray": "Helehalli creeperiembleemiga",
  "block.minecraft.banner.creeper.lime": "Laimirohelise creeperiembleemiga",
  "block.minecraft.banner.creeper.magenta": "Magentapunase creeperiembleemiga",
  "block.minecraft.banner.creeper.orange": "Oranži creeperiembleemiga",
  "block.minecraft.banner.creeper.pink": "Roosa creeperiembleemiga",
  "block.minecraft.banner.creeper.purple": "Lilla creeperiembleemiga",
  "block.minecraft.banner.creeper.red": "Punase creeperiembleemiga",
  "block.minecraft.banner.creeper.white": "Valge creeperiembleemiga",
  "block.minecraft.banner.creeper.yellow": "Kollase creeperiembleemiga",
  "block.minecraft.banner.cross.black": "Musta Andrease ristiga",
  "block.minecraft.banner.cross.blue": "Sinise Andrease ristiga",
  "block.minecraft.banner.cross.brown": "Pruuni Andrease ristiga",
  "block.minecraft.banner.cross.cyan": "Tsüaansinise Andrease ristiga",
  "block.minecraft.banner.cross.gray": "Halli Andrease ristiga",
  "block.minecraft.banner.cross.green": "Rohelise Andrease ristiga",
  "block.minecraft.banner.cross.light_blue": "Helesinise Andrease ristiga",
  "block.minecraft.banner.cross.light_gray": "Helehalli Andrease ristiga",
  "block.minecraft.banner.cross.lime": "Laimirohelise Andrease ristiga",
  "block.minecraft.banner.cross.magenta": "Magentapunase Andrease ristiga",
  "block.minecraft.banner.cross.orange": "Oranži Andrease ristiga",
  "block.minecraft.banner.cross.pink": "Roosa Andrease ristiga",
  "block.minecraft.banner.cross.purple": "Lilla Andrease ristiga",
  "block.minecraft.banner.cross.red": "Punase Andrease ristiga",
  "block.minecraft.banner.cross.white": "Valge Andrease ristiga",
  "block.minecraft.banner.cross.yellow": "Kollase Andrease ristiga",
  "block.minecraft.banner.curly_border.black": "Musta sakkidega poordiga",
  "block.minecraft.banner.curly_border.blue": "Sinise sakkidega poordiga",
  "block.minecraft.banner.curly_border.brown": "Pruuni sakkidega poordiga",
  "block.minecraft.banner.curly_border.cyan": "Tsüaansinise sakkidega poordiga",
  "block.minecraft.banner.curly_border.gray": "Halli sakkidega poordiga",
  "block.minecraft.banner.curly_border.green": "Rohelise sakkidega poordiga",
  "block.minecraft.banner.curly_border.light_blue": "Helesinise sakkidega poordiga",
  "block.minecraft.banner.curly_border.light_gray": "Helehalli sakkidega poordiga",
  "block.minecraft.banner.curly_border.lime": "Laimirohelise sakkidega poordiga",
  "block.minecraft.banner.curly_border.magenta": "Magentapunase sakkidega poordiga",
  "block.minecraft.banner.curly_border.orange": "Oranži sakkidega poordiga",
  "block.minecraft.banner.curly_border.pink": "Roosa sakkidega poordiga",
  "block.minecraft.banner.curly_border.purple": "Lilla sakkidega poordiga",
  "block.minecraft.banner.curly_border.red": "Punase sakkidega poordiga",
  "block.minecraft.banner.curly_border.white": "Valge sakkidega poordiga",
  "block.minecraft.banner.curly_border.yellow": "Kollase sakkidega poordiga",
  "block.minecraft.banner.diagonal_left.black": "Musta täidetud diagonaaliga üleval paremal",
  "block.minecraft.banner.diagonal_left.blue": "Sinise täidetud diagonaaliga üleval paremal",
  "block.minecraft.banner.diagonal_left.brown": "Pruuni täidetud diagonaaliga üleval paremal",
  "block.minecraft.banner.diagonal_left.cyan": "Tsüaansinise täidetud diagonaaliga üleval paremal",
  "block.minecraft.banner.diagonal_left.gray": "Halli täidetud diagonaaliga üleval paremal",
  "block.minecraft.banner.diagonal_left.green": "Rohelise täidetud diagonaaliga üleval paremal",
  "block.minecraft.banner.diagonal_left.light_blue": "Helesinise täidetud diagonaaliga üleval paremal",
  "block.minecraft.banner.diagonal_left.light_gray": "Helehalli täidetud diagonaaliga üleval paremal",
  "block.minecraft.banner.diagonal_left.lime": "Laimirohelise täidetud diagonaaliga üleval paremal",
  "block.minecraft.banner.diagonal_left.magenta": "Magentapunase täidetud diagonaaliga üleval paremal",
  "block.minecraft.banner.diagonal_left.orange": "Oranži täidetud diagonaaliga üleval paremal",
  "block.minecraft.banner.diagonal_left.pink": "Roosa täidetud diagonaaliga üleval paremal",
  "block.minecraft.banner.diagonal_left.purple": "Lilla täidetud diagonaaliga üleval paremal",
  "block.minecraft.banner.diagonal_left.red": "Punase täidetud diagonaaliga üleval paremal",
  "block.minecraft.banner.diagonal_left.white": "Valge täidetud diagonaaliga üleval paremal",
  "block.minecraft.banner.diagonal_left.yellow": "Kollase täidetud diagonaaliga üleval paremal",
  "block.minecraft.banner.diagonal_right.black": "Musta täidetud diagonaaliga üleval vasakul",
  "block.minecraft.banner.diagonal_right.blue": "Sinise täidetud diagonaaliga üleval vasakul",
  "block.minecraft.banner.diagonal_right.brown": "Pruuni täidetud diagonaaliga üleval vasakul",
  "block.minecraft.banner.diagonal_right.cyan": "Tsüaansinise täidetud diagonaaliga üleval vasakul",
  "block.minecraft.banner.diagonal_right.gray": "Halli täidetud diagonaaliga üleval vasakul",
  "block.minecraft.banner.diagonal_right.green": "Rohelise täidetud diagonaaliga üleval vasakul",
  "block.minecraft.banner.diagonal_right.light_blue": "Helesinise täidetud diagonaaliga üleval vasakul",
  "block.minecraft.banner.diagonal_right.light_gray": "Helehalli täidetud diagonaaliga üleval vasakul",
  "block.minecraft.banner.diagonal_right.lime": "Laimirohelise täidetud diagonaaliga üleval vasakul",
  "block.minecraft.banner.diagonal_right.magenta": "Magentapunase täidetud diagonaaliga üleval vasakul",
  "block.minecraft.banner.diagonal_right.orange": "Oranži täidetud diagonaaliga üleval vasakul",
  "block.minecraft.banner.diagonal_right.pink": "Roosa täidetud diagonaaliga üleval vasakul",
  "block.minecraft.banner.diagonal_right.purple": "Lilla täidetud diagonaaliga üleval vasakul",
  "block.minecraft.banner.diagonal_right.red": "Punase täidetud diagonaaliga üleval vasakul",
  "block.minecraft.banner.diagonal_right.white": "Valge täidetud diagonaaliga üleval vasakul",
  "block.minecraft.banner.diagonal_right.yellow": "Kollase täidetud diagonaaliga üleval vasakul",
  "block.minecraft.banner.diagonal_up_left.black": "Musta täidetud diagonaaliga all paremal",
  "block.minecraft.banner.diagonal_up_left.blue": "Sinise täidetud diagonaaliga all paremal",
  "block.minecraft.banner.diagonal_up_left.brown": "Pruuni täidetud diagonaaliga all paremal",
  "block.minecraft.banner.diagonal_up_left.cyan": "Tsüaansinise täidetud diagonaaliga all paremal",
  "block.minecraft.banner.diagonal_up_left.gray": "Halli täidetud diagonaaliga all paremal",
  "block.minecraft.banner.diagonal_up_left.green": "Rohelise täidetud diagonaaliga all paremal",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Helesinise täidetud diagonaaliga all paremal",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Helehalli täidetud diagonaaliga all paremal",
  "block.minecraft.banner.diagonal_up_left.lime": "Laimirohelise täidetud diagonaaliga all paremal",
  "block.minecraft.banner.diagonal_up_left.magenta": "Magentapunase täidetud diagonaaliga all paremal",
  "block.minecraft.banner.diagonal_up_left.orange": "Oranži täidetud diagonaaliga all paremal",
  "block.minecraft.banner.diagonal_up_left.pink": "Roosa täidetud diagonaaliga all paremal",
  "block.minecraft.banner.diagonal_up_left.purple": "Lilla täidetud diagonaaliga all paremal",
  "block.minecraft.banner.diagonal_up_left.red": "Punase täidetud diagonaaliga all paremal",
  "block.minecraft.banner.diagonal_up_left.white": "Valge täidetud diagonaaliga all paremal",
  "block.minecraft.banner.diagonal_up_left.yellow": "Kollase täidetud diagonaaliga all paremal",
  "block.minecraft.banner.diagonal_up_right.black": "Musta täidetud diagonaaliga all vasakul",
  "block.minecraft.banner.diagonal_up_right.blue": "Sinise täidetud diagonaaliga all vasakul",
  "block.minecraft.banner.diagonal_up_right.brown": "Pruuni täidetud diagonaaliga all vasakul",
  "block.minecraft.banner.diagonal_up_right.cyan": "Tsüaansinise täidetud diagonaaliga all vasakul",
  "block.minecraft.banner.diagonal_up_right.gray": "Halli täidetud diagonaaliga all vasakul",
  "block.minecraft.banner.diagonal_up_right.green": "Rohelise täidetud diagonaaliga all vasakul",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Helesinise täidetud diagonaaliga all vasakul",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Helehalli täidetud diagonaaliga all vasakul",
  "block.minecraft.banner.diagonal_up_right.lime": "Laimirohelise täidetud diagonaaliga all vasakul",
  "block.minecraft.banner.diagonal_up_right.magenta": "Magentapunase täidetud diagonaaliga all vasakul",
  "block.minecraft.banner.diagonal_up_right.orange": "Oranži täidetud diagonaaliga all vasakul",
  "block.minecraft.banner.diagonal_up_right.pink": "Roosa täidetud diagonaaliga all vasakul",
  "block.minecraft.banner.diagonal_up_right.purple": "Lilla täidetud diagonaaliga all vasakul",
  "block.minecraft.banner.diagonal_up_right.red": "Punase täidetud diagonaaliga all vasakul",
  "block.minecraft.banner.diagonal_up_right.white": "Valge täidetud diagonaaliga all vasakul",
  "block.minecraft.banner.diagonal_up_right.yellow": "Kollase täidetud diagonaaliga all vasakul",
  "block.minecraft.banner.flow.black": "Musta vooga",
  "block.minecraft.banner.flow.blue": "Sinise vooga",
  "block.minecraft.banner.flow.brown": "Pruuni vooga",
  "block.minecraft.banner.flow.cyan": "Tsüaansinise vooga",
  "block.minecraft.banner.flow.gray": "Halli vooga",
  "block.minecraft.banner.flow.green": "Rohelise vooga",
  "block.minecraft.banner.flow.light_blue": "Helesinise vooga",
  "block.minecraft.banner.flow.light_gray": "Helehalli vooga",
  "block.minecraft.banner.flow.lime": "Laimirohelise vooga",
  "block.minecraft.banner.flow.magenta": "Magentapunase vooga",
  "block.minecraft.banner.flow.orange": "Oranži vooga",
  "block.minecraft.banner.flow.pink": "Roosa vooga",
  "block.minecraft.banner.flow.purple": "Lilla vooga",
  "block.minecraft.banner.flow.red": "Punase vooga",
  "block.minecraft.banner.flow.white": "Valge vooga",
  "block.minecraft.banner.flow.yellow": "Kollase vooga",
  "block.minecraft.banner.flower.black": "Musta lilleembleemiga",
  "block.minecraft.banner.flower.blue": "Sinise lilleembleemiga",
  "block.minecraft.banner.flower.brown": "Pruuni lilleembleemiga",
  "block.minecraft.banner.flower.cyan": "Tsüaansinise lilleembleemiga",
  "block.minecraft.banner.flower.gray": "Halli lilleembleemiga",
  "block.minecraft.banner.flower.green": "Rohelise lilleembleemiga",
  "block.minecraft.banner.flower.light_blue": "Helesinise lilleembleemiga",
  "block.minecraft.banner.flower.light_gray": "Helehalli lilleembleemiga",
  "block.minecraft.banner.flower.lime": "Laimirohelise lilleembleemiga",
  "block.minecraft.banner.flower.magenta": "Magentapunase lilleembleemiga",
  "block.minecraft.banner.flower.orange": "Oranži lilleembleemiga",
  "block.minecraft.banner.flower.pink": "Roosa lilleembleemiga",
  "block.minecraft.banner.flower.purple": "Lilla lilleembleemiga",
  "block.minecraft.banner.flower.red": "Punase lilleembleemiga",
  "block.minecraft.banner.flower.white": "Valge lilleembleemiga",
  "block.minecraft.banner.flower.yellow": "Kollase lilleembleemiga",
  "block.minecraft.banner.globe.black": "Musta gloobusega",
  "block.minecraft.banner.globe.blue": "Sinise gloobusega",
  "block.minecraft.banner.globe.brown": "Pruuni gloobusega",
  "block.minecraft.banner.globe.cyan": "Tsüaansinise gloobusega",
  "block.minecraft.banner.globe.gray": "Halli gloobusega",
  "block.minecraft.banner.globe.green": "Rohelise gloobusega",
  "block.minecraft.banner.globe.light_blue": "Helesinise gloobusega",
  "block.minecraft.banner.globe.light_gray": "Helehalli gloobusega",
  "block.minecraft.banner.globe.lime": "Laimirohelise gloobusega",
  "block.minecraft.banner.globe.magenta": "Magentapunase gloobusega",
  "block.minecraft.banner.globe.orange": "Oranži gloobusega",
  "block.minecraft.banner.globe.pink": "Roosa gloobusega",
  "block.minecraft.banner.globe.purple": "Lilla gloobusega",
  "block.minecraft.banner.globe.red": "Punase gloobusega",
  "block.minecraft.banner.globe.white": "Valge gloobusega",
  "block.minecraft.banner.globe.yellow": "Kollase gloobusega",
  "block.minecraft.banner.gradient.black": "Musta üleminekuga",
  "block.minecraft.banner.gradient.blue": "Sinise üleminekuga",
  "block.minecraft.banner.gradient.brown": "Pruuni üleminekuga",
  "block.minecraft.banner.gradient.cyan": "Tsüaansinise üleminekuga",
  "block.minecraft.banner.gradient.gray": "Halli üleminekuga",
  "block.minecraft.banner.gradient.green": "Rohelise üleminekuga",
  "block.minecraft.banner.gradient.light_blue": "Helesinise üleminekuga",
  "block.minecraft.banner.gradient.light_gray": "Helehalli üleminekuga",
  "block.minecraft.banner.gradient.lime": "Laimirohelise üleminekuga",
  "block.minecraft.banner.gradient.magenta": "Magentapunase üleminekuga",
  "block.minecraft.banner.gradient.orange": "Oranži üleminekuga",
  "block.minecraft.banner.gradient.pink": "Roosa üleminekuga",
  "block.minecraft.banner.gradient.purple": "Lilla üleminekuga",
  "block.minecraft.banner.gradient.red": "Punase üleminekuga",
  "block.minecraft.banner.gradient.white": "Valge üleminekuga",
  "block.minecraft.banner.gradient.yellow": "Kollase üleminekuga",
  "block.minecraft.banner.gradient_up.black": "Musta pööratud üleminekuga",
  "block.minecraft.banner.gradient_up.blue": "Sinise pööratud üleminekuga",
  "block.minecraft.banner.gradient_up.brown": "Pruuni pööratud üleminekuga",
  "block.minecraft.banner.gradient_up.cyan": "Tsüaansinise pööratud üleminekuga",
  "block.minecraft.banner.gradient_up.gray": "Halli pööratud üleminekuga",
  "block.minecraft.banner.gradient_up.green": "Rohelise pööratud üleminekuga",
  "block.minecraft.banner.gradient_up.light_blue": "Helesinise pööratud üleminekuga",
  "block.minecraft.banner.gradient_up.light_gray": "Helehalli pööratud üleminekuga",
  "block.minecraft.banner.gradient_up.lime": "Laimirohelise pööratud üleminekuga",
  "block.minecraft.banner.gradient_up.magenta": "Magentapunase pööratud üleminekuga",
  "block.minecraft.banner.gradient_up.orange": "Oranži pööratud üleminekuga",
  "block.minecraft.banner.gradient_up.pink": "Roosa pööratud üleminekuga",
  "block.minecraft.banner.gradient_up.purple": "Lilla pööratud üleminekuga",
  "block.minecraft.banner.gradient_up.red": "Punase pööratud üleminekuga",
  "block.minecraft.banner.gradient_up.white": "Valge pööratud üleminekuga",
  "block.minecraft.banner.gradient_up.yellow": "Kollase pööratud üleminekuga",
  "block.minecraft.banner.guster.black": "Musta pagijaga",
  "block.minecraft.banner.guster.blue": "Sinise pagijaga",
  "block.minecraft.banner.guster.brown": "Pruuni pagijaga",
  "block.minecraft.banner.guster.cyan": "Tsüaansinise pagijaga",
  "block.minecraft.banner.guster.gray": "Halli pagijaga",
  "block.minecraft.banner.guster.green": "Rohelise pagijaga",
  "block.minecraft.banner.guster.light_blue": "Helesinise pagijaga",
  "block.minecraft.banner.guster.light_gray": "Helehalli pagijaga",
  "block.minecraft.banner.guster.lime": "Laimirohelise pagijaga",
  "block.minecraft.banner.guster.magenta": "Magentapunase pagijaga",
  "block.minecraft.banner.guster.orange": "Oranži pagijaga",
  "block.minecraft.banner.guster.pink": "Roosa pagijaga",
  "block.minecraft.banner.guster.purple": "Lilla pagijaga",
  "block.minecraft.banner.guster.red": "Punase pagijaga",
  "block.minecraft.banner.guster.white": "Valge pagijaga",
  "block.minecraft.banner.guster.yellow": "Kollase pagijaga",
  "block.minecraft.banner.half_horizontal.black": "Musta ülemise poolega",
  "block.minecraft.banner.half_horizontal.blue": "Sinise ülemise poolega",
  "block.minecraft.banner.half_horizontal.brown": "Pruuni ülemise poolega",
  "block.minecraft.banner.half_horizontal.cyan": "Tsüaansinise ülemise poolega",
  "block.minecraft.banner.half_horizontal.gray": "Halli ülemise poolega",
  "block.minecraft.banner.half_horizontal.green": "Rohelise ülemise poolega",
  "block.minecraft.banner.half_horizontal.light_blue": "Helesinise ülemise poolega",
  "block.minecraft.banner.half_horizontal.light_gray": "Helehalli ülemise poolega",
  "block.minecraft.banner.half_horizontal.lime": "Laimirohelise ülemise poolega",
  "block.minecraft.banner.half_horizontal.magenta": "Magentapunase ülemise poolega",
  "block.minecraft.banner.half_horizontal.orange": "Oranži ülemise poolega",
  "block.minecraft.banner.half_horizontal.pink": "Roosa ülemise poolega",
  "block.minecraft.banner.half_horizontal.purple": "Lilla ülemise poolega",
  "block.minecraft.banner.half_horizontal.red": "Punase ülemise poolega",
  "block.minecraft.banner.half_horizontal.white": "Valge ülemise poolega",
  "block.minecraft.banner.half_horizontal.yellow": "Kollase ülemise poolega",
  "block.minecraft.banner.half_horizontal_bottom.black": "Musta alumise poolega",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Sinise alumise poolega",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Pruuni alumise poolega",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Tsüaansinise alumise poolega",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Halli alumise poolega",
  "block.minecraft.banner.half_horizontal_bottom.green": "Rohelise alumise poolega",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Helesinise alumise poolega",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Helehalli alumise poolega",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Laimirohelise alumise poolega",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Magentapunase alumise poolega",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Oranži alumise poolega",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Roosa alumise poolega",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Lilla alumise poolega",
  "block.minecraft.banner.half_horizontal_bottom.red": "Punase alumise poolega",
  "block.minecraft.banner.half_horizontal_bottom.white": "Valge alumise poolega",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Kollase alumise poolega",
  "block.minecraft.banner.half_vertical.black": "Musta parema poolega",
  "block.minecraft.banner.half_vertical.blue": "Sinise parema poolega",
  "block.minecraft.banner.half_vertical.brown": "Pruuni parema poolega",
  "block.minecraft.banner.half_vertical.cyan": "Tsüaansinise parema poolega",
  "block.minecraft.banner.half_vertical.gray": "Halli parema poolega",
  "block.minecraft.banner.half_vertical.green": "Rohelise parema poolega",
  "block.minecraft.banner.half_vertical.light_blue": "Helesinise parema poolega",
  "block.minecraft.banner.half_vertical.light_gray": "Helehalli parema poolega",
  "block.minecraft.banner.half_vertical.lime": "Laimirohelise parema poolega",
  "block.minecraft.banner.half_vertical.magenta": "Magentapunase parema poolega",
  "block.minecraft.banner.half_vertical.orange": "Oranži parema poolega",
  "block.minecraft.banner.half_vertical.pink": "Roosa parema poolega",
  "block.minecraft.banner.half_vertical.purple": "Lilla parema poolega",
  "block.minecraft.banner.half_vertical.red": "Punase parema poolega",
  "block.minecraft.banner.half_vertical.white": "Valge parema poolega",
  "block.minecraft.banner.half_vertical.yellow": "Kollase parema poolega",
  "block.minecraft.banner.half_vertical_right.black": "Musta vasaku poolega",
  "block.minecraft.banner.half_vertical_right.blue": "Sinise vasaku poolega",
  "block.minecraft.banner.half_vertical_right.brown": "Pruuni vasaku poolega",
  "block.minecraft.banner.half_vertical_right.cyan": "Tsüaansinise vasaku poolega",
  "block.minecraft.banner.half_vertical_right.gray": "Halli vasaku poolega",
  "block.minecraft.banner.half_vertical_right.green": "Rohelise vasaku poolega",
  "block.minecraft.banner.half_vertical_right.light_blue": "Helesinise vasaku poolega",
  "block.minecraft.banner.half_vertical_right.light_gray": "Helehalli vasaku poolega",
  "block.minecraft.banner.half_vertical_right.lime": "Laimirohelise vasaku poolega",
  "block.minecraft.banner.half_vertical_right.magenta": "Magentapunase vasaku poolega",
  "block.minecraft.banner.half_vertical_right.orange": "Oranži vasaku poolega",
  "block.minecraft.banner.half_vertical_right.pink": "Roosa vasaku poolega",
  "block.minecraft.banner.half_vertical_right.purple": "Lilla vasaku poolega",
  "block.minecraft.banner.half_vertical_right.red": "Punase vasaku poolega",
  "block.minecraft.banner.half_vertical_right.white": "Valge vasaku poolega",
  "block.minecraft.banner.half_vertical_right.yellow": "Kollase vasaku poolega",
  "block.minecraft.banner.mojang.black": "Musta asjaga",
  "block.minecraft.banner.mojang.blue": "Sinise asjaga",
  "block.minecraft.banner.mojang.brown": "Pruuni asjaga",
  "block.minecraft.banner.mojang.cyan": "Tsüaansinise asjaga",
  "block.minecraft.banner.mojang.gray": "Halli asjaga",
  "block.minecraft.banner.mojang.green": "Rohelise asjaga",
  "block.minecraft.banner.mojang.light_blue": "Helesinise asjaga",
  "block.minecraft.banner.mojang.light_gray": "Helehalli asjaga",
  "block.minecraft.banner.mojang.lime": "Laimirohelise asjaga",
  "block.minecraft.banner.mojang.magenta": "Magentapunase asjaga",
  "block.minecraft.banner.mojang.orange": "Oranži asjaga",
  "block.minecraft.banner.mojang.pink": "Roosa asjaga",
  "block.minecraft.banner.mojang.purple": "Lilla asjaga",
  "block.minecraft.banner.mojang.red": "Punase asjaga",
  "block.minecraft.banner.mojang.white": "Valge asjaga",
  "block.minecraft.banner.mojang.yellow": "Kollase asjaga",
  "block.minecraft.banner.piglin.black": "Musta kärsaga",
  "block.minecraft.banner.piglin.blue": "Sinise kärsaga",
  "block.minecraft.banner.piglin.brown": "Pruuni kärsaga",
  "block.minecraft.banner.piglin.cyan": "Tsüaansinise kärsaga",
  "block.minecraft.banner.piglin.gray": "Halli kärsaga",
  "block.minecraft.banner.piglin.green": "Rohelise kärsaga",
  "block.minecraft.banner.piglin.light_blue": "Helesinise kärsaga",
  "block.minecraft.banner.piglin.light_gray": "Helehalli kärsaga",
  "block.minecraft.banner.piglin.lime": "Laimirohelise kärsaga",
  "block.minecraft.banner.piglin.magenta": "Magentapunase kärsaga",
  "block.minecraft.banner.piglin.orange": "Oranži kärsaga",
  "block.minecraft.banner.piglin.pink": "Roosa kärsaga",
  "block.minecraft.banner.piglin.purple": "Lilla kärsaga",
  "block.minecraft.banner.piglin.red": "Punase kärsaga",
  "block.minecraft.banner.piglin.white": "Valge kärsaga",
  "block.minecraft.banner.piglin.yellow": "Kollase kärsaga",
  "block.minecraft.banner.rhombus.black": "Musta rombiga",
  "block.minecraft.banner.rhombus.blue": "Sinise rombiga",
  "block.minecraft.banner.rhombus.brown": "Pruuni rombiga",
  "block.minecraft.banner.rhombus.cyan": "Tsüaansinise rombiga",
  "block.minecraft.banner.rhombus.gray": "Halli rombiga",
  "block.minecraft.banner.rhombus.green": "Rohelise rombiga",
  "block.minecraft.banner.rhombus.light_blue": "Helesinise rombiga",
  "block.minecraft.banner.rhombus.light_gray": "Helehalli rombiga",
  "block.minecraft.banner.rhombus.lime": "Laimirohelise rombiga",
  "block.minecraft.banner.rhombus.magenta": "Magentapunase rombiga",
  "block.minecraft.banner.rhombus.orange": "Oranži rombiga",
  "block.minecraft.banner.rhombus.pink": "Roosa rombiga",
  "block.minecraft.banner.rhombus.purple": "Lilla rombiga",
  "block.minecraft.banner.rhombus.red": "Punase rombiga",
  "block.minecraft.banner.rhombus.white": "Valge rombiga",
  "block.minecraft.banner.rhombus.yellow": "Kollase rombiga",
  "block.minecraft.banner.skull.black": "Musta pealuuembleemiga",
  "block.minecraft.banner.skull.blue": "Sinise pealuuembleemiga",
  "block.minecraft.banner.skull.brown": "Pruuni pealuuembleemiga",
  "block.minecraft.banner.skull.cyan": "Tsüaansinise pealuuembleemiga",
  "block.minecraft.banner.skull.gray": "Halli pealuuembleemiga",
  "block.minecraft.banner.skull.green": "Rohelise pealuuembleemiga",
  "block.minecraft.banner.skull.light_blue": "Helesinise pealuuembleemiga",
  "block.minecraft.banner.skull.light_gray": "Helehalli pealuuembleemiga",
  "block.minecraft.banner.skull.lime": "Laimirohelise pealuuembleemiga",
  "block.minecraft.banner.skull.magenta": "Magentapunase pealuuembleemiga",
  "block.minecraft.banner.skull.orange": "Oranži pealuuembleemiga",
  "block.minecraft.banner.skull.pink": "Roosa pealuuembleemiga",
  "block.minecraft.banner.skull.purple": "Lilla pealuuembleemiga",
  "block.minecraft.banner.skull.red": "Punase pealuuembleemiga",
  "block.minecraft.banner.skull.white": "Valge pealuuembleemiga",
  "block.minecraft.banner.skull.yellow": "Kollase pealuuembleemiga",
  "block.minecraft.banner.small_stripes.black": "Mustade vertikaalsete viirgudega",
  "block.minecraft.banner.small_stripes.blue": "Siniste vertikaalsete viirgudega",
  "block.minecraft.banner.small_stripes.brown": "Pruunide vertikaalsete viirgudega",
  "block.minecraft.banner.small_stripes.cyan": "Tsüaansiniste vertikaalsete viirgudega",
  "block.minecraft.banner.small_stripes.gray": "Hallide vertikaalsete viirgudega",
  "block.minecraft.banner.small_stripes.green": "Roheliste vertikaalsete viirgudega",
  "block.minecraft.banner.small_stripes.light_blue": "Helesiniste vertikaalsete viirgudega",
  "block.minecraft.banner.small_stripes.light_gray": "Helehallide vertikaalsete viirgudega",
  "block.minecraft.banner.small_stripes.lime": "Laimiroheliste vertikaalsete viirgudega",
  "block.minecraft.banner.small_stripes.magenta": "Magentapunaste vertikaalsete viirgudega",
  "block.minecraft.banner.small_stripes.orange": "Oranžide vertikaalsete viirgudega",
  "block.minecraft.banner.small_stripes.pink": "Roosade vertikaalsete viirgudega",
  "block.minecraft.banner.small_stripes.purple": "Lillade vertikaalsete viirgudega",
  "block.minecraft.banner.small_stripes.red": "Punaste vertikaalsete viirgudega",
  "block.minecraft.banner.small_stripes.white": "Valgete vertikaalsete viirgudega",
  "block.minecraft.banner.small_stripes.yellow": "Kollaste vertikaalsete viirgudega",
  "block.minecraft.banner.square_bottom_left.black": "Musta ruuduga all paremas nurgas",
  "block.minecraft.banner.square_bottom_left.blue": "Sinise ruuduga all paremas nurgas",
  "block.minecraft.banner.square_bottom_left.brown": "Pruuni ruuduga all paremas nurgas",
  "block.minecraft.banner.square_bottom_left.cyan": "Tsüaansinise ruuduga all paremas nurgas",
  "block.minecraft.banner.square_bottom_left.gray": "Halli ruuduga all paremas nurgas",
  "block.minecraft.banner.square_bottom_left.green": "Rohelise ruuduga all paremas nurgas",
  "block.minecraft.banner.square_bottom_left.light_blue": "Helesinise ruuduga all paremas nurgas",
  "block.minecraft.banner.square_bottom_left.light_gray": "Helehalli ruuduga all paremas nurgas",
  "block.minecraft.banner.square_bottom_left.lime": "Laimirohelise ruuduga all paremas nurgas",
  "block.minecraft.banner.square_bottom_left.magenta": "Magentapunase ruuduga all paremas nurgas",
  "block.minecraft.banner.square_bottom_left.orange": "Oranži ruuduga all paremas nurgas",
  "block.minecraft.banner.square_bottom_left.pink": "Roosa ruuduga all paremas nurgas",
  "block.minecraft.banner.square_bottom_left.purple": "Lilla ruuduga all paremas nurgas",
  "block.minecraft.banner.square_bottom_left.red": "Punase ruuduga all paremas nurgas",
  "block.minecraft.banner.square_bottom_left.white": "Valge ruuduga all paremas nurgas",
  "block.minecraft.banner.square_bottom_left.yellow": "Kollase ruuduga all paremas nurgas",
  "block.minecraft.banner.square_bottom_right.black": "Musta ruuduga all vasakus nurgas",
  "block.minecraft.banner.square_bottom_right.blue": "Sinise ruuduga all vasakus nurgas",
  "block.minecraft.banner.square_bottom_right.brown": "Pruuni ruuduga all vasakus nurgas",
  "block.minecraft.banner.square_bottom_right.cyan": "Tsüaansinise ruuduga all vasakus nurgas",
  "block.minecraft.banner.square_bottom_right.gray": "Halli ruuduga all vasakus nurgas",
  "block.minecraft.banner.square_bottom_right.green": "Rohelise ruuduga all vasakus nurgas",
  "block.minecraft.banner.square_bottom_right.light_blue": "Helesinise ruuduga all vasakus nurgas",
  "block.minecraft.banner.square_bottom_right.light_gray": "Helehalli ruuduga all vasakus nurgas",
  "block.minecraft.banner.square_bottom_right.lime": "Laimirohelise ruuduga all vasakus nurgas",
  "block.minecraft.banner.square_bottom_right.magenta": "Magentapunase ruuduga all vasakus nurgas",
  "block.minecraft.banner.square_bottom_right.orange": "Oranži ruuduga all vasakus nurgas",
  "block.minecraft.banner.square_bottom_right.pink": "Roosa ruuduga all vasakus nurgas",
  "block.minecraft.banner.square_bottom_right.purple": "Lilla ruuduga all vasakus nurgas",
  "block.minecraft.banner.square_bottom_right.red": "Punase ruuduga all vasakus nurgas",
  "block.minecraft.banner.square_bottom_right.white": "Valge ruuduga all vasakus nurgas",
  "block.minecraft.banner.square_bottom_right.yellow": "Kollase ruuduga all vasakus nurgas",
  "block.minecraft.banner.square_top_left.black": "Musta ruuduga üleval paremas nurgas",
  "block.minecraft.banner.square_top_left.blue": "Sinise ruuduga üleval paremas nurgas",
  "block.minecraft.banner.square_top_left.brown": "Pruuni ruuduga üleval paremas nurgas",
  "block.minecraft.banner.square_top_left.cyan": "Tsüaansinise ruuduga üleval paremas nurgas",
  "block.minecraft.banner.square_top_left.gray": "Halli ruuduga üleval paremas nurgas",
  "block.minecraft.banner.square_top_left.green": "Rohelise ruuduga üleval paremas nurgas",
  "block.minecraft.banner.square_top_left.light_blue": "Helesinise ruuduga üleval paremas nurgas",
  "block.minecraft.banner.square_top_left.light_gray": "Helehalli ruuduga üleval paremas nurgas",
  "block.minecraft.banner.square_top_left.lime": "Laimirohelise ruuduga üleval paremas nurgas",
  "block.minecraft.banner.square_top_left.magenta": "Magentapunase ruuduga üleval paremas nurgas",
  "block.minecraft.banner.square_top_left.orange": "Oranži ruuduga üleval paremas nurgas",
  "block.minecraft.banner.square_top_left.pink": "Roosa ruuduga üleval paremas nurgas",
  "block.minecraft.banner.square_top_left.purple": "Lilla ruuduga üleval paremas nurgas",
  "block.minecraft.banner.square_top_left.red": "Punase ruuduga üleval paremas nurgas",
  "block.minecraft.banner.square_top_left.white": "Valge ruuduga üleval paremas nurgas",
  "block.minecraft.banner.square_top_left.yellow": "Kollase ruuduga üleval paremas nurgas",
  "block.minecraft.banner.square_top_right.black": "Musta ruuduga üleval vasakus nurgas",
  "block.minecraft.banner.square_top_right.blue": "Sinise ruuduga üleval vasakus nurgas",
  "block.minecraft.banner.square_top_right.brown": "Pruuni ruuduga üleval vasakus nurgas",
  "block.minecraft.banner.square_top_right.cyan": "Tsüaansinise ruuduga üleval vasakus nurgas",
  "block.minecraft.banner.square_top_right.gray": "Halli ruuduga üleval vasakus nurgas",
  "block.minecraft.banner.square_top_right.green": "Rohelise ruuduga üleval vasakus nurgas",
  "block.minecraft.banner.square_top_right.light_blue": "Helesinise ruuduga üleval vasakus nurgas",
  "block.minecraft.banner.square_top_right.light_gray": "Helehalli ruuduga üleval vasakus nurgas",
  "block.minecraft.banner.square_top_right.lime": "Laimirohelise ruuduga üleval vasakus nurgas",
  "block.minecraft.banner.square_top_right.magenta": "Magentapunase ruuduga üleval vasakus nurgas",
  "block.minecraft.banner.square_top_right.orange": "Oranži ruuduga üleval vasakus nurgas",
  "block.minecraft.banner.square_top_right.pink": "Roosa ruuduga üleval vasakus nurgas",
  "block.minecraft.banner.square_top_right.purple": "Lilla ruuduga üleval vasakus nurgas",
  "block.minecraft.banner.square_top_right.red": "Punase ruuduga üleval vasakus nurgas",
  "block.minecraft.banner.square_top_right.white": "Valge ruuduga üleval vasakus nurgas",
  "block.minecraft.banner.square_top_right.yellow": "Kollase ruuduga üleval vasakus nurgas",
  "block.minecraft.banner.straight_cross.black": "Musta ristiga",
  "block.minecraft.banner.straight_cross.blue": "Sinise ristiga",
  "block.minecraft.banner.straight_cross.brown": "Pruuni ristiga",
  "block.minecraft.banner.straight_cross.cyan": "Tsüaansinise ristiga",
  "block.minecraft.banner.straight_cross.gray": "Halli ristiga",
  "block.minecraft.banner.straight_cross.green": "Rohelise ristiga",
  "block.minecraft.banner.straight_cross.light_blue": "Helesinise ristiga",
  "block.minecraft.banner.straight_cross.light_gray": "Helehalli ristiga",
  "block.minecraft.banner.straight_cross.lime": "Laimirohelise ristiga",
  "block.minecraft.banner.straight_cross.magenta": "Magentapunase ristiga",
  "block.minecraft.banner.straight_cross.orange": "Oranži ristiga",
  "block.minecraft.banner.straight_cross.pink": "Roosa ristiga",
  "block.minecraft.banner.straight_cross.purple": "Lilla ristiga",
  "block.minecraft.banner.straight_cross.red": "Punase ristiga",
  "block.minecraft.banner.straight_cross.white": "Valge ristiga",
  "block.minecraft.banner.straight_cross.yellow": "Kollase ristiga",
  "block.minecraft.banner.stripe_bottom.black": "Musta joonega all",
  "block.minecraft.banner.stripe_bottom.blue": "Sinise joonega all",
  "block.minecraft.banner.stripe_bottom.brown": "Pruuni joonega all",
  "block.minecraft.banner.stripe_bottom.cyan": "Tsüaansinise joonega all",
  "block.minecraft.banner.stripe_bottom.gray": "Halli joonega all",
  "block.minecraft.banner.stripe_bottom.green": "Rohelise joonega all",
  "block.minecraft.banner.stripe_bottom.light_blue": "Helesinise joonega all",
  "block.minecraft.banner.stripe_bottom.light_gray": "Helehalli joonega all",
  "block.minecraft.banner.stripe_bottom.lime": "Laimirohelise joonega all",
  "block.minecraft.banner.stripe_bottom.magenta": "Magentapunase joonega all",
  "block.minecraft.banner.stripe_bottom.orange": "Oranži joonega all",
  "block.minecraft.banner.stripe_bottom.pink": "Roosa joonega all",
  "block.minecraft.banner.stripe_bottom.purple": "Lilla joonega all",
  "block.minecraft.banner.stripe_bottom.red": "Punase joonega all",
  "block.minecraft.banner.stripe_bottom.white": "Valge joonega all",
  "block.minecraft.banner.stripe_bottom.yellow": "Kollase joonega all",
  "block.minecraft.banner.stripe_center.black": "Musta vertikaalse joonega keskel",
  "block.minecraft.banner.stripe_center.blue": "Sinise vertikaalse joonega keskel",
  "block.minecraft.banner.stripe_center.brown": "Pruuni vertikaalse joonega keskel",
  "block.minecraft.banner.stripe_center.cyan": "Tsüaansinise vertikaalse joonega keskel",
  "block.minecraft.banner.stripe_center.gray": "Halli vertikaalse joonega keskel",
  "block.minecraft.banner.stripe_center.green": "Rohelise vertikaalse joonega keskel",
  "block.minecraft.banner.stripe_center.light_blue": "Helesinise vertikaalse joonega keskel",
  "block.minecraft.banner.stripe_center.light_gray": "Helehalli vertikaalse joonega keskel",
  "block.minecraft.banner.stripe_center.lime": "Laimirohelise vertikaalse joonega keskel",
  "block.minecraft.banner.stripe_center.magenta": "Magentapunase vertikaalse joonega keskel",
  "block.minecraft.banner.stripe_center.orange": "Oranži vertikaalse joonega keskel",
  "block.minecraft.banner.stripe_center.pink": "Roosa vertikaalse joonega keskel",
  "block.minecraft.banner.stripe_center.purple": "Lilla vertikaalse joonega keskel",
  "block.minecraft.banner.stripe_center.red": "Punase vertikaalse joonega keskel",
  "block.minecraft.banner.stripe_center.white": "Valge vertikaalse joonega keskel",
  "block.minecraft.banner.stripe_center.yellow": "Kollase vertikaalse joonega keskel",
  "block.minecraft.banner.stripe_downleft.black": "Musta pööratud loogega",
  "block.minecraft.banner.stripe_downleft.blue": "Sinise pööratud loogega",
  "block.minecraft.banner.stripe_downleft.brown": "Pruuni pööratud loogega",
  "block.minecraft.banner.stripe_downleft.cyan": "Tsüaansinise pööratud loogega",
  "block.minecraft.banner.stripe_downleft.gray": "Halli pööratud loogega",
  "block.minecraft.banner.stripe_downleft.green": "Rohelise pööratud loogega",
  "block.minecraft.banner.stripe_downleft.light_blue": "Helesinise pööratud loogega",
  "block.minecraft.banner.stripe_downleft.light_gray": "Helehalli pööratud loogega",
  "block.minecraft.banner.stripe_downleft.lime": "Laimirohelise pööratud loogega",
  "block.minecraft.banner.stripe_downleft.magenta": "Magentapunase pööratud loogega",
  "block.minecraft.banner.stripe_downleft.orange": "Oranži pööratud loogega",
  "block.minecraft.banner.stripe_downleft.pink": "Roosa pööratud loogega",
  "block.minecraft.banner.stripe_downleft.purple": "Lilla pööratud loogega",
  "block.minecraft.banner.stripe_downleft.red": "Punase pööratud loogega",
  "block.minecraft.banner.stripe_downleft.white": "Valge pööratud loogega",
  "block.minecraft.banner.stripe_downleft.yellow": "Kollase pööratud loogega",
  "block.minecraft.banner.stripe_downright.black": "Musta loogega",
  "block.minecraft.banner.stripe_downright.blue": "Sinise loogega",
  "block.minecraft.banner.stripe_downright.brown": "Pruuni loogega",
  "block.minecraft.banner.stripe_downright.cyan": "Tsüaansinise loogega",
  "block.minecraft.banner.stripe_downright.gray": "Halli loogega",
  "block.minecraft.banner.stripe_downright.green": "Rohelise loogega",
  "block.minecraft.banner.stripe_downright.light_blue": "Helesinise loogega",
  "block.minecraft.banner.stripe_downright.light_gray": "Helehalli loogega",
  "block.minecraft.banner.stripe_downright.lime": "Laimirohelise loogega",
  "block.minecraft.banner.stripe_downright.magenta": "Magentapunase loogega",
  "block.minecraft.banner.stripe_downright.orange": "Oranži loogega",
  "block.minecraft.banner.stripe_downright.pink": "Roosa loogega",
  "block.minecraft.banner.stripe_downright.purple": "Lilla loogega",
  "block.minecraft.banner.stripe_downright.red": "Punase loogega",
  "block.minecraft.banner.stripe_downright.white": "Valge loogega",
  "block.minecraft.banner.stripe_downright.yellow": "Kollase loogega",
  "block.minecraft.banner.stripe_left.black": "Musta flangiga paremal",
  "block.minecraft.banner.stripe_left.blue": "Sinise flangiga paremal",
  "block.minecraft.banner.stripe_left.brown": "Pruuni flangiga paremal",
  "block.minecraft.banner.stripe_left.cyan": "Tsüaansinise flangiga paremal",
  "block.minecraft.banner.stripe_left.gray": "Halli flangiga paremal",
  "block.minecraft.banner.stripe_left.green": "Rohelise flangiga paremal",
  "block.minecraft.banner.stripe_left.light_blue": "Helesinise flangiga paremal",
  "block.minecraft.banner.stripe_left.light_gray": "Helehalli flangiga paremal",
  "block.minecraft.banner.stripe_left.lime": "Laimirohelise flangiga paremal",
  "block.minecraft.banner.stripe_left.magenta": "Magentapunase flangiga paremal",
  "block.minecraft.banner.stripe_left.orange": "Oranži flangiga paremal",
  "block.minecraft.banner.stripe_left.pink": "Roosa flangiga paremal",
  "block.minecraft.banner.stripe_left.purple": "Lilla flangiga paremal",
  "block.minecraft.banner.stripe_left.red": "Punase flangiga paremal",
  "block.minecraft.banner.stripe_left.white": "Valge flangiga paremal",
  "block.minecraft.banner.stripe_left.yellow": "Kollase flangiga paremal",
  "block.minecraft.banner.stripe_middle.black": "Musta horisontaalse joonega keskel",
  "block.minecraft.banner.stripe_middle.blue": "Sinise horisontaalse joonega keskel",
  "block.minecraft.banner.stripe_middle.brown": "Pruuni horisontaalse joonega keskel",
  "block.minecraft.banner.stripe_middle.cyan": "Tsüaansinise horisontaalse joonega keskel",
  "block.minecraft.banner.stripe_middle.gray": "Halli horisontaalse joonega keskel",
  "block.minecraft.banner.stripe_middle.green": "Rohelise horisontaalse joonega keskel",
  "block.minecraft.banner.stripe_middle.light_blue": "Helesinise horisontaalse joonega keskel",
  "block.minecraft.banner.stripe_middle.light_gray": "Helehalli horisontaalse joonega keskel",
  "block.minecraft.banner.stripe_middle.lime": "Laimirohelise horisontaalse joonega keskel",
  "block.minecraft.banner.stripe_middle.magenta": "Magentapunase horisontaalse joonega keskel",
  "block.minecraft.banner.stripe_middle.orange": "Oranži horisontaalse joonega keskel",
  "block.minecraft.banner.stripe_middle.pink": "Roosa horisontaalse joonega keskel",
  "block.minecraft.banner.stripe_middle.purple": "Lilla horisontaalse joonega keskel",
  "block.minecraft.banner.stripe_middle.red": "Punase horisontaalse joonega keskel",
  "block.minecraft.banner.stripe_middle.white": "Valge horisontaalse joonega keskel",
  "block.minecraft.banner.stripe_middle.yellow": "Kollase horisontaalse joonega keskel",
  "block.minecraft.banner.stripe_right.black": "Musta flangiga vasakul",
  "block.minecraft.banner.stripe_right.blue": "Sinise flangiga vasakul",
  "block.minecraft.banner.stripe_right.brown": "Pruuni flangiga vasakul",
  "block.minecraft.banner.stripe_right.cyan": "Tsüaansinise flangiga vasakul",
  "block.minecraft.banner.stripe_right.gray": "Halli flangiga vasakul",
  "block.minecraft.banner.stripe_right.green": "Rohelise flangiga vasakul",
  "block.minecraft.banner.stripe_right.light_blue": "Helesinise flangiga vasakul",
  "block.minecraft.banner.stripe_right.light_gray": "Helehalli flangiga vasakul",
  "block.minecraft.banner.stripe_right.lime": "Laimirohelise flangiga vasakul",
  "block.minecraft.banner.stripe_right.magenta": "Magentapunase flangiga vasakul",
  "block.minecraft.banner.stripe_right.orange": "Oranži flangiga vasakul",
  "block.minecraft.banner.stripe_right.pink": "Roosa flangiga vasakul",
  "block.minecraft.banner.stripe_right.purple": "Lilla flangiga vasakul",
  "block.minecraft.banner.stripe_right.red": "Punase flangiga vasakul",
  "block.minecraft.banner.stripe_right.white": "Valge flangiga vasakul",
  "block.minecraft.banner.stripe_right.yellow": "Kollase flangiga vasakul",
  "block.minecraft.banner.stripe_top.black": "Musta joonega üleval",
  "block.minecraft.banner.stripe_top.blue": "Sinise joonega üleval",
  "block.minecraft.banner.stripe_top.brown": "Pruuni joonega üleval",
  "block.minecraft.banner.stripe_top.cyan": "Tsüaansinise joonega üleval",
  "block.minecraft.banner.stripe_top.gray": "Halli joonega üleval",
  "block.minecraft.banner.stripe_top.green": "Rohelise joonega üleval",
  "block.minecraft.banner.stripe_top.light_blue": "Helesinise joonega üleval",
  "block.minecraft.banner.stripe_top.light_gray": "Helehalli joonega üleval",
  "block.minecraft.banner.stripe_top.lime": "Laimirohelise joonega üleval",
  "block.minecraft.banner.stripe_top.magenta": "Magentapunase joonega üleval",
  "block.minecraft.banner.stripe_top.orange": "Oranži joonega üleval",
  "block.minecraft.banner.stripe_top.pink": "Roosa joonega üleval",
  "block.minecraft.banner.stripe_top.purple": "Lilla joonega üleval",
  "block.minecraft.banner.stripe_top.red": "Punase joonega üleval",
  "block.minecraft.banner.stripe_top.white": "Valge joonega üleval",
  "block.minecraft.banner.stripe_top.yellow": "Kollase joonega üleval",
  "block.minecraft.banner.triangle_bottom.black": "Musta kolmnurgaga",
  "block.minecraft.banner.triangle_bottom.blue": "Sinise kolmnurgaga",
  "block.minecraft.banner.triangle_bottom.brown": "Pruuni kolmnurgaga",
  "block.minecraft.banner.triangle_bottom.cyan": "Tsüaansinise kolmnurgaga",
  "block.minecraft.banner.triangle_bottom.gray": "Halli kolmnurgaga",
  "block.minecraft.banner.triangle_bottom.green": "Rohelise kolmnurgaga",
  "block.minecraft.banner.triangle_bottom.light_blue": "Helesinise kolmnurgaga",
  "block.minecraft.banner.triangle_bottom.light_gray": "Helehalli kolmnurgaga",
  "block.minecraft.banner.triangle_bottom.lime": "Laimirohelise kolmnurgaga",
  "block.minecraft.banner.triangle_bottom.magenta": "Magentapunase kolmnurgaga",
  "block.minecraft.banner.triangle_bottom.orange": "Oranži kolmnurgaga",
  "block.minecraft.banner.triangle_bottom.pink": "Roosa kolmnurgaga",
  "block.minecraft.banner.triangle_bottom.purple": "Lilla kolmnurgaga",
  "block.minecraft.banner.triangle_bottom.red": "Punase kolmnurgaga",
  "block.minecraft.banner.triangle_bottom.white": "Valge kolmnurgaga",
  "block.minecraft.banner.triangle_bottom.yellow": "Kollase kolmnurgaga",
  "block.minecraft.banner.triangle_top.black": "Musta pööratud kolmnurgaga",
  "block.minecraft.banner.triangle_top.blue": "Sinise pööratud kolmnurgaga",
  "block.minecraft.banner.triangle_top.brown": "Pruuni pööratud kolmnurgaga",
  "block.minecraft.banner.triangle_top.cyan": "Tsüaansinise pööratud kolmnurgaga",
  "block.minecraft.banner.triangle_top.gray": "Halli pööratud kolmnurgaga",
  "block.minecraft.banner.triangle_top.green": "Rohelise pööratud kolmnurgaga",
  "block.minecraft.banner.triangle_top.light_blue": "Helesinise pööratud kolmnurgaga",
  "block.minecraft.banner.triangle_top.light_gray": "Helehalli pööratud kolmnurgaga",
  "block.minecraft.banner.triangle_top.lime": "Laimirohelise pööratud kolmnurgaga",
  "block.minecraft.banner.triangle_top.magenta": "Magentapunase pööratud kolmnurgaga",
  "block.minecraft.banner.triangle_top.orange": "Oranži pööratud kolmnurgaga",
  "block.minecraft.banner.triangle_top.pink": "Roosa pööratud kolmnurgaga",
  "block.minecraft.banner.triangle_top.purple": "Lilla pööratud kolmnurgaga",
  "block.minecraft.banner.triangle_top.red": "Punase pööratud kolmnurgaga",
  "block.minecraft.banner.triangle_top.white": "Valge pööratud kolmnurgaga",
  "block.minecraft.banner.triangle_top.yellow": "Kollase pööratud kolmnurgaga",
  "block.minecraft.banner.triangles_bottom.black": "Mustade alumiste sakkidega",
  "block.minecraft.banner.triangles_bottom.blue": "Siniste alumiste sakkidega",
  "block.minecraft.banner.triangles_bottom.brown": "Pruunide alumiste sakkidega",
  "block.minecraft.banner.triangles_bottom.cyan": "Tsüaansiniste alumiste sakkidega",
  "block.minecraft.banner.triangles_bottom.gray": "Hallide alumiste sakkidega",
  "block.minecraft.banner.triangles_bottom.green": "Roheliste alumiste sakkidega",
  "block.minecraft.banner.triangles_bottom.light_blue": "Helesiniste alumiste sakkidega",
  "block.minecraft.banner.triangles_bottom.light_gray": "Helehallide alumiste sakkidega",
  "block.minecraft.banner.triangles_bottom.lime": "Laimiroheliste alumiste sakkidega",
  "block.minecraft.banner.triangles_bottom.magenta": "Magentapunase alumiste sakkidega",
  "block.minecraft.banner.triangles_bottom.orange": "Oranžide alumiste sakkidega",
  "block.minecraft.banner.triangles_bottom.pink": "Roosade alumiste sakkidega",
  "block.minecraft.banner.triangles_bottom.purple": "Lillade alumiste sakkidega",
  "block.minecraft.banner.triangles_bottom.red": "Punaste alumiste sakkidega",
  "block.minecraft.banner.triangles_bottom.white": "Valgete alumiste sakkidega",
  "block.minecraft.banner.triangles_bottom.yellow": "Kollaste alumiste sakkidega",
  "block.minecraft.banner.triangles_top.black": "Mustade ülemiste sakkidega",
  "block.minecraft.banner.triangles_top.blue": "Siniste ülemiste sakkidega",
  "block.minecraft.banner.triangles_top.brown": "Pruunide ülemiste sakkidega",
  "block.minecraft.banner.triangles_top.cyan": "Tsüaansiniste ülemiste sakkidega",
  "block.minecraft.banner.triangles_top.gray": "Hallide ülemiste sakkidega",
  "block.minecraft.banner.triangles_top.green": "Roheliste ülemiste sakkidega",
  "block.minecraft.banner.triangles_top.light_blue": "Helesiniste ülemiste sakkidega",
  "block.minecraft.banner.triangles_top.light_gray": "Helehallide ülemiste sakkidega",
  "block.minecraft.banner.triangles_top.lime": "Laimiroheliste ülemiste sakkidega",
  "block.minecraft.banner.triangles_top.magenta": "Magentapunase ülemiste sakkidega",
  "block.minecraft.banner.triangles_top.orange": "Oranžide ülemiste sakkidega",
  "block.minecraft.banner.triangles_top.pink": "Roosade ülemiste sakkidega",
  "block.minecraft.banner.triangles_top.purple": "Lillade ülemiste sakkidega",
  "block.minecraft.banner.triangles_top.red": "Punaste ülemiste sakkidega",
  "block.minecraft.banner.triangles_top.white": "Valgete ülemiste sakkidega",
  "block.minecraft.banner.triangles_top.yellow": "Kollaste ülemiste sakkidega",
  "block.minecraft.barrel": "Tünn",
  "block.minecraft.barrier": "Ääris",
  "block.minecraft.basalt": "Basalt",
  "block.minecraft.beacon": "Majakas",
  "block.minecraft.beacon.primary": "Peamine mõju",
  "block.minecraft.beacon.secondary": "Teisane mõju",
  "block.minecraft.bed.no_sleep": "Sa saad magada ainult öösiti või äikesetormide ajal",
  "block.minecraft.bed.not_safe": "Sa ei saa hetkel puhata, läheduses on koletisi",
  "block.minecraft.bed.obstructed": "See voodi on tõkestatud",
  "block.minecraft.bed.occupied": "See voodi on hõivatud",
  "block.minecraft.bed.too_far_away": "Sa ei saa hetkel puhata, voodi on liiga kaugel",
  "block.minecraft.bedrock": "Aluskivi",
  "block.minecraft.bee_nest": "Mesilaspesa",
  "block.minecraft.beehive": "Mesitaru",
  "block.minecraft.beetroots": "Peedid",
  "block.minecraft.bell": "Kelluke",
  "block.minecraft.big_dripleaf": "Suur tilkeleht",
  "block.minecraft.big_dripleaf_stem": "Suure tilkelehe vars",
  "block.minecraft.birch_button": "Kasenupp",
  "block.minecraft.birch_door": "Kasest uks",
  "block.minecraft.birch_fence": "Kasest aed",
  "block.minecraft.birch_fence_gate": "Kasest aiavärav",
  "block.minecraft.birch_hanging_sign": "Kasest rippuv silt",
  "block.minecraft.birch_leaves": "Kaselehed",
  "block.minecraft.birch_log": "Kasepalk",
  "block.minecraft.birch_planks": "Kaselauad",
  "block.minecraft.birch_pressure_plate": "Kasest surveplaat",
  "block.minecraft.birch_sapling": "Kaseistik",
  "block.minecraft.birch_shelf": "Kasest riiul",
  "block.minecraft.birch_sign": "Kasest silt",
  "block.minecraft.birch_slab": "Kaseplaat",
  "block.minecraft.birch_stairs": "Kasetrepp",
  "block.minecraft.birch_trapdoor": "Kaseluuk",
  "block.minecraft.birch_wall_hanging_sign": "Kasest seinal rippuv silt",
  "block.minecraft.birch_wall_sign": "Kasest seinasilt",
  "block.minecraft.birch_wood": "Kasepuit",
  "block.minecraft.black_banner": "Must plakat",
  "block.minecraft.black_bed": "Must voodi",
  "block.minecraft.black_candle": "Must küünal",
  "block.minecraft.black_candle_cake": "Musta küünlaga kook",
  "block.minecraft.black_carpet": "Must vaip",
  "block.minecraft.black_concrete": "Must betoon",
  "block.minecraft.black_concrete_powder": "Must betoonipulber",
  "block.minecraft.black_glazed_terracotta": "Must glasuuritud terrakota",
  "block.minecraft.black_shulker_box": "Must šulkerikast",
  "block.minecraft.black_stained_glass": "Musta värviga klaas",
  "block.minecraft.black_stained_glass_pane": "Musta värviga klaaspaneel",
  "block.minecraft.black_terracotta": "Must terrakota",
  "block.minecraft.black_wool": "Must vill",
  "block.minecraft.blackstone": "Mustkivi",
  "block.minecraft.blackstone_slab": "Mustkiviplaat",
  "block.minecraft.blackstone_stairs": "Mustkivitrepp",
  "block.minecraft.blackstone_wall": "Mustkivimüür",
  "block.minecraft.blast_furnace": "Kõrgahi",
  "block.minecraft.blue_banner": "Sinine plakat",
  "block.minecraft.blue_bed": "Sinine voodi",
  "block.minecraft.blue_candle": "Sinine küünal",
  "block.minecraft.blue_candle_cake": "Sinise küünlaga kook",
  "block.minecraft.blue_carpet": "Sinine vaip",
  "block.minecraft.blue_concrete": "Sinine betoon",
  "block.minecraft.blue_concrete_powder": "Sinine betoonipulber",
  "block.minecraft.blue_glazed_terracotta": "Sinine glasuuritud terrakota",
  "block.minecraft.blue_ice": "Sinine jää",
  "block.minecraft.blue_orchid": "Sinine orhidee",
  "block.minecraft.blue_shulker_box": "Sinine šulkerikast",
  "block.minecraft.blue_stained_glass": "Sinise värviga klaas",
  "block.minecraft.blue_stained_glass_pane": "Sinise värviga klaaspaneel",
  "block.minecraft.blue_terracotta": "Sinine terrakota",
  "block.minecraft.blue_wool": "Sinine vill",
  "block.minecraft.bone_block": "Kondiplokk",
  "block.minecraft.bookshelf": "Raamaturiiul",
  "block.minecraft.brain_coral": "Ajukorall",
  "block.minecraft.brain_coral_block": "Ajukoralli plokk",
  "block.minecraft.brain_coral_fan": "Ajukoralli lehvik",
  "block.minecraft.brain_coral_wall_fan": "Ajukoralli seinalehvik",
  "block.minecraft.brewing_stand": "Pruulimisalus",
  "block.minecraft.brick_slab": "Tellisplaat",
  "block.minecraft.brick_stairs": "Tellistrepp",
  "block.minecraft.brick_wall": "Tellismüür",
  "block.minecraft.bricks": "Tellised",
  "block.minecraft.brown_banner": "Pruun plakat",
  "block.minecraft.brown_bed": "Pruun voodi",
  "block.minecraft.brown_candle": "Pruun küünal",
  "block.minecraft.brown_candle_cake": "Pruuni küünlaga kook",
  "block.minecraft.brown_carpet": "Pruun vaip",
  "block.minecraft.brown_concrete": "Pruun betoon",
  "block.minecraft.brown_concrete_powder": "Pruun betoonipulber",
  "block.minecraft.brown_glazed_terracotta": "Pruun glasuuritud terrakota",
  "block.minecraft.brown_mushroom": "Pruun seen",
  "block.minecraft.brown_mushroom_block": "Pruun seeneplokk",
  "block.minecraft.brown_shulker_box": "Pruun šulkerikast",
  "block.minecraft.brown_stained_glass": "Pruuni värviga klaas",
  "block.minecraft.brown_stained_glass_pane": "Pruuni värviga klaaspaneel",
  "block.minecraft.brown_terracotta": "Pruun terrakota",
  "block.minecraft.brown_wool": "Pruun vill",
  "block.minecraft.bubble_column": "Mullijuga",
  "block.minecraft.bubble_coral": "Mullkorall",
  "block.minecraft.bubble_coral_block": "Mullkoralli plokk",
  "block.minecraft.bubble_coral_fan": "Mullkoralli lehvik",
  "block.minecraft.bubble_coral_wall_fan": "Mullkoralli seinalehvik",
  "block.minecraft.budding_amethyst": "Tärkav ametüst",
  "block.minecraft.bush": "Põõsas",
  "block.minecraft.cactus": "Kaktus",
  "block.minecraft.cactus_flower": "Kaktuslill",
  "block.minecraft.cake": "Kook",
  "block.minecraft.calcite": "Kaltsiit",
  "block.minecraft.calibrated_sculk_sensor": "Kalibreeritud sculk-sensor",
  "block.minecraft.campfire": "Lõkketuli",
  "block.minecraft.candle": "Küünal",
  "block.minecraft.candle_cake": "Küünlaga kook",
  "block.minecraft.carrots": "Porgandid",
  "block.minecraft.cartography_table": "Kartograafialaud",
  "block.minecraft.carved_pumpkin": "Nikerdatud kõrvits",
  "block.minecraft.cauldron": "Pada",
  "block.minecraft.cave_air": "Koopaõhk",
  "block.minecraft.cave_vines": "Koopaväädid",
  "block.minecraft.cave_vines_plant": "Koopaväätide taim",
  "block.minecraft.chain": "Kett",
  "block.minecraft.chain_command_block": "Ketistatud käsuplokk",
  "block.minecraft.cherry_button": "Kirsipuidust nupp",
  "block.minecraft.cherry_door": "Kirsipuidust uks",
  "block.minecraft.cherry_fence": "Kirsipuidust aed",
  "block.minecraft.cherry_fence_gate": "Kirsipuidust aiavärav",
  "block.minecraft.cherry_hanging_sign": "Kirsipuidust rippuv silt",
  "block.minecraft.cherry_leaves": "Kirsipuu lehed",
  "block.minecraft.cherry_log": "Kirsipuu palk",
  "block.minecraft.cherry_planks": "Kirsipuidust lauad",
  "block.minecraft.cherry_pressure_plate": "Kirsipuidust surveplaat",
  "block.minecraft.cherry_sapling": "Kirsipuu istik",
  "block.minecraft.cherry_shelf": "Kirsipuidust riiul",
  "block.minecraft.cherry_sign": "Kirsipuidust silt",
  "block.minecraft.cherry_slab": "Kirsipuidust plaat",
  "block.minecraft.cherry_stairs": "Kirsipuidust trepp",
  "block.minecraft.cherry_trapdoor": "Kirsipuidust luuk",
  "block.minecraft.cherry_wall_hanging_sign": "Kirsipuidust seinal rippuv silt",
  "block.minecraft.cherry_wall_sign": "Kirsipuidust seinasilt",
  "block.minecraft.cherry_wood": "Kirsipuit",
  "block.minecraft.chest": "Kirst",
  "block.minecraft.chipped_anvil": "Täkkega alasi",
  "block.minecraft.chiseled_bookshelf": "Tahutud raamaturiiul",
  "block.minecraft.chiseled_copper": "Tahutud vask",
  "block.minecraft.chiseled_deepslate": "Tahutud sügavkilt",
  "block.minecraft.chiseled_nether_bricks": "Tahutud nether-tellised",
  "block.minecraft.chiseled_polished_blackstone": "Tahutud lihvitud mustkivi",
  "block.minecraft.chiseled_quartz_block": "Tahutud kvartsplokk",
  "block.minecraft.chiseled_red_sandstone": "Tahutud punane liivakivi",
  "block.minecraft.chiseled_resin_bricks": "Tahutud vaigutellised",
  "block.minecraft.chiseled_sandstone": "Tahutud liivakivi",
  "block.minecraft.chiseled_stone_bricks": "Tahutud kivitellised",
  "block.minecraft.chiseled_tuff": "Tahutud tuff",
  "block.minecraft.chiseled_tuff_bricks": "Tahutud tufitellised",
  "block.minecraft.chorus_flower": "Koorilill",
  "block.minecraft.chorus_plant": "Kooritaim",
  "block.minecraft.clay": "Savi",
  "block.minecraft.closed_eyeblossom": "Suletud silmaõis",
  "block.minecraft.coal_block": "Söeplokk",
  "block.minecraft.coal_ore": "Söemaak",
  "block.minecraft.coarse_dirt": "Jäme muld",
  "block.minecraft.cobbled_deepslate": "Sillutatud sügavkilt",
  "block.minecraft.cobbled_deepslate_slab": "Sillutatud sügavkildast plaat",
  "block.minecraft.cobbled_deepslate_stairs": "Sillutatud sügavkildast trepp",
  "block.minecraft.cobbled_deepslate_wall": "Sillutatud sügavkildast müür",
  "block.minecraft.cobblestone": "Munakivi",
  "block.minecraft.cobblestone_slab": "Munakiviplaat",
  "block.minecraft.cobblestone_stairs": "Munakivitrepp",
  "block.minecraft.cobblestone_wall": "Munakivimüür",
  "block.minecraft.cobweb": "Ämblikuvõrk",
  "block.minecraft.cocoa": "Kakao",
  "block.minecraft.command_block": "Käsuplokk",
  "block.minecraft.comparator": "Redstone'i komparaator",
  "block.minecraft.composter": "Komposter",
  "block.minecraft.conduit": "Siire",
  "block.minecraft.copper_bars": "Vasktrellid",
  "block.minecraft.copper_block": "Vaseplokk",
  "block.minecraft.copper_bulb": "Vaskpirn",
  "block.minecraft.copper_chain": "Vaskkett",
  "block.minecraft.copper_chest": "Vasest kirst",
  "block.minecraft.copper_door": "Vaskuks",
  "block.minecraft.copper_golem_statue": "Vaskgolemi kuju",
  "block.minecraft.copper_grate": "Vaskvõre",
  "block.minecraft.copper_lantern": "Vasklatern",
  "block.minecraft.copper_ore": "Vasemaak",
  "block.minecraft.copper_torch": "Vasktõrvik",
  "block.minecraft.copper_trapdoor": "Vaskluuk",
  "block.minecraft.copper_wall_torch": "Vasest seinatõrvik",
  "block.minecraft.cornflower": "Rukkilill",
  "block.minecraft.cracked_deepslate_bricks": "Pragunenud sügavkildatellised",
  "block.minecraft.cracked_deepslate_tiles": "Pragunenud sügavkildakahlid",
  "block.minecraft.cracked_nether_bricks": "Pragunenud nether-tellised",
  "block.minecraft.cracked_polished_blackstone_bricks": "Pragunenud lihvitud mustkivi tellised",
  "block.minecraft.cracked_stone_bricks": "Pragunenud kivitellised",
  "block.minecraft.crafter": "Meisterdaja",
  "block.minecraft.crafting_table": "Meisterduslaud",
  "block.minecraft.creaking_heart": "Kriiksuv süda",
  "block.minecraft.creeper_head": "Creeperi pea",
  "block.minecraft.creeper_wall_head": "Creeperi seinapea",
  "block.minecraft.crimson_button": "Karmiinpunane nupp",
  "block.minecraft.crimson_door": "Karmiinpunane uks",
  "block.minecraft.crimson_fence": "Karmiinpunane aed",
  "block.minecraft.crimson_fence_gate": "Karmiinpunane aiavärav",
  "block.minecraft.crimson_fungus": "Karmiinpunane seen",
  "block.minecraft.crimson_hanging_sign": "Karmiinpunane rippuv silt",
  "block.minecraft.crimson_hyphae": "Karmiinpunased hüüfid",
  "block.minecraft.crimson_nylium": "Karmiinpunane netseel",
  "block.minecraft.crimson_planks": "Karmiinpunased lauad",
  "block.minecraft.crimson_pressure_plate": "Karmiinpunane surveplaat",
  "block.minecraft.crimson_roots": "Karmiinpunased juured",
  "block.minecraft.crimson_shelf": "Karmiinpunane riiul",
  "block.minecraft.crimson_sign": "Karmiinpunane silt",
  "block.minecraft.crimson_slab": "Karmiinpunane plaat",
  "block.minecraft.crimson_stairs": "Karmiinpunane trepp",
  "block.minecraft.crimson_stem": "Karmiinpunane vars",
  "block.minecraft.crimson_trapdoor": "Karmiinpunane luuk",
  "block.minecraft.crimson_wall_hanging_sign": "Karmiinpunane seinal rippuv silt",
  "block.minecraft.crimson_wall_sign": "Karmiinpunane seinasilt",
  "block.minecraft.crying_obsidian": "Nuttev obsidiaan",
  "block.minecraft.cut_copper": "Lõigatud vask",
  "block.minecraft.cut_copper_slab": "Lõigatud vasest plaat",
  "block.minecraft.cut_copper_stairs": "Lõigatud vasest trepp",
  "block.minecraft.cut_red_sandstone": "Lõigatud punane liivakivi",
  "block.minecraft.cut_red_sandstone_slab": "Lõigatud punasest liivakivist plaat",
  "block.minecraft.cut_sandstone": "Lõigatud liivakivi",
  "block.minecraft.cut_sandstone_slab": "Lõigatud liivakivist plaat",
  "block.minecraft.cyan_banner": "Tsüaansinine plakat",
  "block.minecraft.cyan_bed": "Tsüaansinine voodi",
  "block.minecraft.cyan_candle": "Tsüaansinine küünal",
  "block.minecraft.cyan_candle_cake": "Tsüaansinise küünlaga kook",
  "block.minecraft.cyan_carpet": "Tsüaansinine vaip",
  "block.minecraft.cyan_concrete": "Tsüaansinine betoon",
  "block.minecraft.cyan_concrete_powder": "Tsüaansinine betoonipulber",
  "block.minecraft.cyan_glazed_terracotta": "Tsüaansinine glasuuritud terrakota",
  "block.minecraft.cyan_shulker_box": "Tsüaansinine šulkerikast",
  "block.minecraft.cyan_stained_glass": "Tsüaansinise värviga klaas",
  "block.minecraft.cyan_stained_glass_pane": "Tsüaansinise värviga klaaspaneel",
  "block.minecraft.cyan_terracotta": "Tsüaansinine terrakota",
  "block.minecraft.cyan_wool": "Tsüaansinine vill",
  "block.minecraft.damaged_anvil": "Kahjustunud alasi",
  "block.minecraft.dandelion": "Võilill",
  "block.minecraft.dark_oak_button": "Tumedast tammest nupp",
  "block.minecraft.dark_oak_door": "Tumedast tammest uks",
  "block.minecraft.dark_oak_fence": "Tumedast tammest aed",
  "block.minecraft.dark_oak_fence_gate": "Tumedast tammest aiavärav",
  "block.minecraft.dark_oak_hanging_sign": "Tumedast tammest rippuv silt",
  "block.minecraft.dark_oak_leaves": "Tumeda tamme lehed",
  "block.minecraft.dark_oak_log": "Tumeda tamme palk",
  "block.minecraft.dark_oak_planks": "Tumeda tamme lauad",
  "block.minecraft.dark_oak_pressure_plate": "Tumedast tammest surveplaat",
  "block.minecraft.dark_oak_sapling": "Tumeda tamme istik",
  "block.minecraft.dark_oak_shelf": "Tumedast tammest riiul",
  "block.minecraft.dark_oak_sign": "Tumedast tammest silt",
  "block.minecraft.dark_oak_slab": "Tumeda tamme plaat",
  "block.minecraft.dark_oak_stairs": "Tumedast tammest trepp",
  "block.minecraft.dark_oak_trapdoor": "Tumedast tammest luuk",
  "block.minecraft.dark_oak_wall_hanging_sign": "Tumedast tammest seinal rippuv silt",
  "block.minecraft.dark_oak_wall_sign": "Tumedast tammest seinasilt",
  "block.minecraft.dark_oak_wood": "Tumeda tamme puit",
  "block.minecraft.dark_prismarine": "Tume prismariin",
  "block.minecraft.dark_prismarine_slab": "Tumedast prismariinist plaat",
  "block.minecraft.dark_prismarine_stairs": "Tumedast prismariinist trepp",
  "block.minecraft.daylight_detector": "Päevavalguse andur",
  "block.minecraft.dead_brain_coral": "Surnud ajukorall",
  "block.minecraft.dead_brain_coral_block": "Surnud ajukoralli plokk",
  "block.minecraft.dead_brain_coral_fan": "Surnud ajukoralli lehvik",
  "block.minecraft.dead_brain_coral_wall_fan": "Surnud ajukoralli seinalehvik",
  "block.minecraft.dead_bubble_coral": "Surnud mullkorall",
  "block.minecraft.dead_bubble_coral_block": "Surnud mullkoralli plokk",
  "block.minecraft.dead_bubble_coral_fan": "Surnud mullkoralli lehvik",
  "block.minecraft.dead_bubble_coral_wall_fan": "Surnud mullkoralli seinalehvik",
  "block.minecraft.dead_bush": "Surnud põõsas",
  "block.minecraft.dead_fire_coral": "Surnud tulikorall",
  "block.minecraft.dead_fire_coral_block": "Surnud tulikoralli plokk",
  "block.minecraft.dead_fire_coral_fan": "Surnud tulikoralli lehvik",
  "block.minecraft.dead_fire_coral_wall_fan": "Surnud tulikoralli seinalehvik",
  "block.minecraft.dead_horn_coral": "Surnud sarvkorall",
  "block.minecraft.dead_horn_coral_block": "Surnud sarvkoralli plokk",
  "block.minecraft.dead_horn_coral_fan": "Surnud sarvkoralli lehvik",
  "block.minecraft.dead_horn_coral_wall_fan": "Surnud sarvkoralli seinalehvik",
  "block.minecraft.dead_tube_coral": "Surnud torukorall",
  "block.minecraft.dead_tube_coral_block": "Surnud torukoralli plokk",
  "block.minecraft.dead_tube_coral_fan": "Surnud torukoralli lehvik",
  "block.minecraft.dead_tube_coral_wall_fan": "Surnud torukoralli seinalehvik",
  "block.minecraft.decorated_pot": "Kaunistatud pott",
  "block.minecraft.deepslate": "Sügavkilt",
  "block.minecraft.deepslate_brick_slab": "Sügavkilda tellisplaat",
  "block.minecraft.deepslate_brick_stairs": "Sügavkilda tellistrepp",
  "block.minecraft.deepslate_brick_wall": "Sügavkildatellistest müür",
  "block.minecraft.deepslate_bricks": "Sügavkildatellised",
  "block.minecraft.deepslate_coal_ore": "Sügavkilda söemaak",
  "block.minecraft.deepslate_copper_ore": "Sügavkilda vasemaak",
  "block.minecraft.deepslate_diamond_ore": "Sügavkilda teemantmaak",
  "block.minecraft.deepslate_emerald_ore": "Sügavkilda smaragdimaak",
  "block.minecraft.deepslate_gold_ore": "Sügavkilda kullamaak",
  "block.minecraft.deepslate_iron_ore": "Sügavkilda rauamaak",
  "block.minecraft.deepslate_lapis_ore": "Sügavkilda lasuriidimaak",
  "block.minecraft.deepslate_redstone_ore": "Sügavkilda redstone-maak",
  "block.minecraft.deepslate_tile_slab": "Sügavkildakahlist plaat",
  "block.minecraft.deepslate_tile_stairs": "Sügavkildakahlist trepp",
  "block.minecraft.deepslate_tile_wall": "Sügavkildakahlist müür",
  "block.minecraft.deepslate_tiles": "Sügavkildakahlid",
  "block.minecraft.detector_rail": "Andurrööpad",
  "block.minecraft.diamond_block": "Teemantplokk",
  "block.minecraft.diamond_ore": "Teemantmaak",
  "block.minecraft.diorite": "Dioriit",
  "block.minecraft.diorite_slab": "Dioriitplaat",
  "block.minecraft.diorite_stairs": "Dioriit-trepp",
  "block.minecraft.diorite_wall": "Dioriitmüür",
  "block.minecraft.dirt": "Muld",
  "block.minecraft.dirt_path": "Mullarada",
  "block.minecraft.dispenser": "Jaotur",
  "block.minecraft.dragon_egg": "Draakonimuna",
  "block.minecraft.dragon_head": "Draakoni pea",
  "block.minecraft.dragon_wall_head": "Draakoni seinapea",
  "block.minecraft.dried_ghast": "Kuivanud ghast",
  "block.minecraft.dried_kelp_block": "Kuivatatud vetikaplokk",
  "block.minecraft.dripstone_block": "Tilkekivi plokk",
  "block.minecraft.dropper": "Heitja",
  "block.minecraft.emerald_block": "Smaragdiplokk",
  "block.minecraft.emerald_ore": "Smaragdimaak",
  "block.minecraft.enchanting_table": "Loitsimislaud",
  "block.minecraft.end_gateway": "Endi läbipääs",
  "block.minecraft.end_portal": "Endi portaal",
  "block.minecraft.end_portal_frame": "Endi portaali raam",
  "block.minecraft.end_rod": "Endivarras",
  "block.minecraft.end_stone": "Endikivi",
  "block.minecraft.end_stone_brick_slab": "Endikivi tellisplaat",
  "block.minecraft.end_stone_brick_stairs": "Endikivi tellistrepp",
  "block.minecraft.end_stone_brick_wall": "Endikivi tellistest müür",
  "block.minecraft.end_stone_bricks": "Endikivist tellised",
  "block.minecraft.ender_chest": "Enderikirst",
  "block.minecraft.exposed_chiseled_copper": "Pleekinud tahutud vask",
  "block.minecraft.exposed_copper": "Pleekinud vask",
  "block.minecraft.exposed_copper_bars": "Pleekinud vasktrellid",
  "block.minecraft.exposed_copper_bulb": "Pleekinud vaskpirn",
  "block.minecraft.exposed_copper_chain": "Pleekinud vaskkett",
  "block.minecraft.exposed_copper_chest": "Pleekinud vasest kirst",
  "block.minecraft.exposed_copper_door": "Pleekinud vaskuks",
  "block.minecraft.exposed_copper_golem_statue": "Pleekinud vaskgolemi kuju",
  "block.minecraft.exposed_copper_grate": "Pleekinud vaskvõre",
  "block.minecraft.exposed_copper_lantern": "Pleekinud vasklatern",
  "block.minecraft.exposed_copper_trapdoor": "Pleekinud vaskluuk",
  "block.minecraft.exposed_cut_copper": "Pleekinud lõigatud vask",
  "block.minecraft.exposed_cut_copper_slab": "Pleekinud lõigatud vasest plaat",
  "block.minecraft.exposed_cut_copper_stairs": "Pleekinud lõigatud vasest trepp",
  "block.minecraft.exposed_lightning_rod": "Pleekinud piksevarras",
  "block.minecraft.farmland": "Põllumaa",
  "block.minecraft.fern": "Sõnajalg",
  "block.minecraft.fire": "Tuli",
  "block.minecraft.fire_coral": "Tulikorall",
  "block.minecraft.fire_coral_block": "Tulikoralli plokk",
  "block.minecraft.fire_coral_fan": "Tulikoralli lehvik",
  "block.minecraft.fire_coral_wall_fan": "Tulikoralli seinalehvik",
  "block.minecraft.firefly_bush": "Jaanimardikapõõsas",
  "block.minecraft.fletching_table": "Noolekinnituslaud",
  "block.minecraft.flower_pot": "Lillepott",
  "block.minecraft.flowering_azalea": "Õitsev asalea",
  "block.minecraft.flowering_azalea_leaves": "Õitseva asalea lehed",
  "block.minecraft.frogspawn": "Konnakudu",
  "block.minecraft.frosted_ice": "Härmatunud jää",
  "block.minecraft.furnace": "Ahi",
  "block.minecraft.gilded_blackstone": "Kullatud mustkivi",
  "block.minecraft.glass": "Klaas",
  "block.minecraft.glass_pane": "Klaaspaneel",
  "block.minecraft.glow_lichen": "Hõõgsamblik",
  "block.minecraft.glowstone": "Hõõgkivi",
  "block.minecraft.gold_block": "Kullaplokk",
  "block.minecraft.gold_ore": "Kullamaak",
  "block.minecraft.golden_dandelion": "Kuldne võilill",
  "block.minecraft.granite": "Graniit",
  "block.minecraft.granite_slab": "Graniitplaat",
  "block.minecraft.granite_stairs": "Graniit-trepp",
  "block.minecraft.granite_wall": "Graniitmüür",
  "block.minecraft.grass": "Muru",
  "block.minecraft.grass_block": "Muruplokk",
  "block.minecraft.gravel": "Kruus",
  "block.minecraft.gray_banner": "Hall plakat",
  "block.minecraft.gray_bed": "Hall voodi",
  "block.minecraft.gray_candle": "Hall küünal",
  "block.minecraft.gray_candle_cake": "Halli küünlaga kook",
  "block.minecraft.gray_carpet": "Hall vaip",
  "block.minecraft.gray_concrete": "Hall betoon",
  "block.minecraft.gray_concrete_powder": "Hall betoonipulber",
  "block.minecraft.gray_glazed_terracotta": "Hall glasuuritud terrakota",
  "block.minecraft.gray_shulker_box": "Hall šulkerikast",
  "block.minecraft.gray_stained_glass": "Halli värviga klaas",
  "block.minecraft.gray_stained_glass_pane": "Halli värviga klaaspaneel",
  "block.minecraft.gray_terracotta": "Hall terrakota",
  "block.minecraft.gray_wool": "Hall vill",
  "block.minecraft.green_banner": "Roheline plakat",
  "block.minecraft.green_bed": "Roheline voodi",
  "block.minecraft.green_candle": "Roheline küünal",
  "block.minecraft.green_candle_cake": "Rohelise küünlaga kook",
  "block.minecraft.green_carpet": "Roheline vaip",
  "block.minecraft.green_concrete": "Roheline betoon",
  "block.minecraft.green_concrete_powder": "Roheline betoonipulber",
  "block.minecraft.green_glazed_terracotta": "Roheline glasuuritud terrakota",
  "block.minecraft.green_shulker_box": "Roheline šulkerikast",
  "block.minecraft.green_stained_glass": "Rohelise värviga klaas",
  "block.minecraft.green_stained_glass_pane": "Rohelise värviga klaaspaneel",
  "block.minecraft.green_terracotta": "Roheline terrakota",
  "block.minecraft.green_wool": "Roheline vill",
  "block.minecraft.grindstone": "Käiakivi",
  "block.minecraft.hanging_roots": "Rippuvad juured",
  "block.minecraft.hay_block": "Heinapall",
  "block.minecraft.heavy_core": "Raske tuum",
  "block.minecraft.heavy_weighted_pressure_plate": "Raskekaaluline surveplaat",
  "block.minecraft.honey_block": "Meeplokk",
  "block.minecraft.honeycomb_block": "Meekärjeplokk",
  "block.minecraft.hopper": "Püüdja",
  "block.minecraft.horn_coral": "Sarvkorall",
  "block.minecraft.horn_coral_block": "Sarvkoralli plokk",
  "block.minecraft.horn_coral_fan": "Sarvkoralli lehvik",
  "block.minecraft.horn_coral_wall_fan": "Sarvkoralli seinalehvik",
  "block.minecraft.ice": "Jää",
  "block.minecraft.infested_chiseled_stone_bricks": "Parasiitsed tahutud kivitellised",
  "block.minecraft.infested_cobblestone": "Parasiitne munakivi",
  "block.minecraft.infested_cracked_stone_bricks": "Parasiitsed pragunenud kivitellised",
  "block.minecraft.infested_deepslate": "Parasiitne sügavkilt",
  "block.minecraft.infested_mossy_stone_bricks": "Parasiitsed sammaldunud kivitellised",
  "block.minecraft.infested_stone": "Parasiitne kivi",
  "block.minecraft.infested_stone_bricks": "Parasiitsed kivitellised",
  "block.minecraft.iron_bars": "Raudtrellid",
  "block.minecraft.iron_block": "Rauaplokk",
  "block.minecraft.iron_chain": "Raudkett",
  "block.minecraft.iron_door": "Rauduks",
  "block.minecraft.iron_ore": "Rauamaak",
  "block.minecraft.iron_trapdoor": "Raudluuk",
  "block.minecraft.jack_o_lantern": "Kõrvitsalatern",
  "block.minecraft.jigsaw": "Pusleplokk",
  "block.minecraft.jukebox": "Plaadimängija",
  "block.minecraft.jungle_button": "Džunglipuidust nupp",
  "block.minecraft.jungle_door": "Džunglipuidust uks",
  "block.minecraft.jungle_fence": "Džunglipuidust aed",
  "block.minecraft.jungle_fence_gate": "Džunglipuidust aiavärav",
  "block.minecraft.jungle_hanging_sign": "Džunglipuidust rippuv silt",
  "block.minecraft.jungle_leaves": "Džunglipuu lehed",
  "block.minecraft.jungle_log": "Džunglipuu palk",
  "block.minecraft.jungle_planks": "Džunglipuidust lauad",
  "block.minecraft.jungle_pressure_plate": "Džunglipuidust surveplaat",
  "block.minecraft.jungle_sapling": "Džunglipuu istik",
  "block.minecraft.jungle_shelf": "Džunglipuidust riiul",
  "block.minecraft.jungle_sign": "Džunglipuidust silt",
  "block.minecraft.jungle_slab": "Džunglipuidust plaat",
  "block.minecraft.jungle_stairs": "Džunglipuidust trepp",
  "block.minecraft.jungle_trapdoor": "Džunglipuidust luuk",
  "block.minecraft.jungle_wall_hanging_sign": "Džunglipuidust seinal rippuv silt",
  "block.minecraft.jungle_wall_sign": "Džunglipuidust seinasilt",
  "block.minecraft.jungle_wood": "Džunglipuit",
  "block.minecraft.kelp": "Vetikas",
  "block.minecraft.kelp_plant": "Vetikataim",
  "block.minecraft.ladder": "Redel",
  "block.minecraft.lantern": "Latern",
  "block.minecraft.lapis_block": "Lasuriidiplokk",
  "block.minecraft.lapis_ore": "Lasuriidimaak",
  "block.minecraft.large_amethyst_bud": "Suur ametüstipung",
  "block.minecraft.large_fern": "Kõrge sõnajalg",
  "block.minecraft.lava": "Laava",
  "block.minecraft.lava_cauldron": "Laavapada",
  "block.minecraft.leaf_litter": "Leherisu",
  "block.minecraft.lectern": "Kõnepult",
  "block.minecraft.lever": "Kang",
  "block.minecraft.light": "Valgus",
  "block.minecraft.light_blue_banner": "Helesinine plakat",
  "block.minecraft.light_blue_bed": "Helesinine voodi",
  "block.minecraft.light_blue_candle": "Helesinine küünal",
  "block.minecraft.light_blue_candle_cake": "Helesinise küünlaga kook",
  "block.minecraft.light_blue_carpet": "Helesinine vaip",
  "block.minecraft.light_blue_concrete": "Helesinine betoon",
  "block.minecraft.light_blue_concrete_powder": "Helesinine betoonipulber",
  "block.minecraft.light_blue_glazed_terracotta": "Helesinine glasuuritud terrakota",
  "block.minecraft.light_blue_shulker_box": "Helesinine šulkerikast",
  "block.minecraft.light_blue_stained_glass": "Helesinise värviga klaas",
  "block.minecraft.light_blue_stained_glass_pane": "Helesinise värviga klaaspaneel",
  "block.minecraft.light_blue_terracotta": "Helesinine terrakota",
  "block.minecraft.light_blue_wool": "Helesinine vill",
  "block.minecraft.light_gray_banner": "Helehall plakat",
  "block.minecraft.light_gray_bed": "Helehall voodi",
  "block.minecraft.light_gray_candle": "Helehall küünal",
  "block.minecraft.light_gray_candle_cake": "Helehalli küünlaga kook",
  "block.minecraft.light_gray_carpet": "Helehall vaip",
  "block.minecraft.light_gray_concrete": "Helehall betoon",
  "block.minecraft.light_gray_concrete_powder": "Helehall betoonipulber",
  "block.minecraft.light_gray_glazed_terracotta": "Helehall glasuuritud terrakota",
  "block.minecraft.light_gray_shulker_box": "Helehall šulkerikast",
  "block.minecraft.light_gray_stained_glass": "Helehalli värviga klaas",
  "block.minecraft.light_gray_stained_glass_pane": "Helehalli värviga klaaspaneel",
  "block.minecraft.light_gray_terracotta": "Helehall terrakota",
  "block.minecraft.light_gray_wool": "Helehall vill",
  "block.minecraft.light_weighted_pressure_plate": "Kergekaaluline surveplaat",
  "block.minecraft.lightning_rod": "Piksevarras",
  "block.minecraft.lilac": "Sirel",
  "block.minecraft.lily_of_the_valley": "Maikelluke",
  "block.minecraft.lily_pad": "Vesiroosileht",
  "block.minecraft.lime_banner": "Laimiroheline plakat",
  "block.minecraft.lime_bed": "Laimiroheline voodi",
  "block.minecraft.lime_candle": "Laimiroheline küünal",
  "block.minecraft.lime_candle_cake": "Laimirohelise küünlaga kook",
  "block.minecraft.lime_carpet": "Laimiroheline vaip",
  "block.minecraft.lime_concrete": "Laimiroheline betoon",
  "block.minecraft.lime_concrete_powder": "Laimiroheline betoonipulber",
  "block.minecraft.lime_glazed_terracotta": "Laimiroheline glasuuritud terrakota",
  "block.minecraft.lime_shulker_box": "Laimiroheline šulkerikast",
  "block.minecraft.lime_stained_glass": "Laimirohelise värviga klaas",
  "block.minecraft.lime_stained_glass_pane": "Laimirohelise värviga klaaspaneel",
  "block.minecraft.lime_terracotta": "Laimiroheline terrakota",
  "block.minecraft.lime_wool": "Laimiroheline vill",
  "block.minecraft.lodestone": "Teekivi",
  "block.minecraft.loom": "Kangasteljed",
  "block.minecraft.magenta_banner": "Magentapunane plakat",
  "block.minecraft.magenta_bed": "Magentapunane voodi",
  "block.minecraft.magenta_candle": "Magentapunane küünal",
  "block.minecraft.magenta_candle_cake": "Magentapunase küünlaga kook",
  "block.minecraft.magenta_carpet": "Magentapunane vaip",
  "block.minecraft.magenta_concrete": "Magentapunane betoon",
  "block.minecraft.magenta_concrete_powder": "Magentapunane betoonipulber",
  "block.minecraft.magenta_glazed_terracotta": "Magentapunane glasuuritud terrakota",
  "block.minecraft.magenta_shulker_box": "Magentapunane šulkerikast",
  "block.minecraft.magenta_stained_glass": "Magentapunase värviga klaas",
  "block.minecraft.magenta_stained_glass_pane": "Magentapunase värviga klaaspaneel",
  "block.minecraft.magenta_terracotta": "Magentapunane terrakota",
  "block.minecraft.magenta_wool": "Magentapunane vill",
  "block.minecraft.magma_block": "Magmaplokk",
  "block.minecraft.mangrove_button": "Mangroovinupp",
  "block.minecraft.mangrove_door": "Mangroovist uks",
  "block.minecraft.mangrove_fence": "Mangroovist aed",
  "block.minecraft.mangrove_fence_gate": "Mangroovist aiavärav",
  "block.minecraft.mangrove_hanging_sign": "Mangroovist rippuv silt",
  "block.minecraft.mangrove_leaves": "Mangroovilehed",
  "block.minecraft.mangrove_log": "Mangroovipalk",
  "block.minecraft.mangrove_planks": "Mangroovilauad",
  "block.minecraft.mangrove_pressure_plate": "Mangroovist surveplaat",
  "block.minecraft.mangrove_propagule": "Mangroovi sigipung",
  "block.minecraft.mangrove_roots": "Mangroovijuured",
  "block.minecraft.mangrove_shelf": "Mangroovist riiul",
  "block.minecraft.mangrove_sign": "Mangroovist silt",
  "block.minecraft.mangrove_slab": "Mangrooviplaat",
  "block.minecraft.mangrove_stairs": "Mangroovitrepp",
  "block.minecraft.mangrove_trapdoor": "Mangrooviluuk",
  "block.minecraft.mangrove_wall_hanging_sign": "Mangroovist seinal rippuv silt",
  "block.minecraft.mangrove_wall_sign": "Mangroovist seinasilt",
  "block.minecraft.mangrove_wood": "Mangroovipuit",
  "block.minecraft.medium_amethyst_bud": "Keskmine ametüstipung",
  "block.minecraft.melon": "Arbuus",
  "block.minecraft.melon_stem": "Arbuusivars",
  "block.minecraft.moss_block": "Samblaplokk",
  "block.minecraft.moss_carpet": "Samblavaip",
  "block.minecraft.mossy_cobblestone": "Sammaldunud munakivi",
  "block.minecraft.mossy_cobblestone_slab": "Sammaldunud munakiviplaat",
  "block.minecraft.mossy_cobblestone_stairs": "Sammaldunud munakivitrepp",
  "block.minecraft.mossy_cobblestone_wall": "Sammaldunud munakivimüür",
  "block.minecraft.mossy_stone_brick_slab": "Sammaldunud kivitellisplaat",
  "block.minecraft.mossy_stone_brick_stairs": "Sammaldunud kivitellistrepp",
  "block.minecraft.mossy_stone_brick_wall": "Sammaldunud kivitellistest müür",
  "block.minecraft.mossy_stone_bricks": "Sammaldunud kivitellised",
  "block.minecraft.moving_piston": "Liikuv kolb",
  "block.minecraft.mud": "Muda",
  "block.minecraft.mud_brick_slab": "Mudatellisplaat",
  "block.minecraft.mud_brick_stairs": "Mudatellistrepp",
  "block.minecraft.mud_brick_wall": "Mudatellistest müür",
  "block.minecraft.mud_bricks": "Mudatellised",
  "block.minecraft.muddy_mangrove_roots": "Mudased mangroovijuured",
  "block.minecraft.mushroom_stem": "Seenejalg",
  "block.minecraft.mycelium": "Mütseel",
  "block.minecraft.nether_brick_fence": "Nether-tellistest aed",
  "block.minecraft.nether_brick_slab": "Nether-tellisplaat",
  "block.minecraft.nether_brick_stairs": "Nether-tellistrepp",
  "block.minecraft.nether_brick_wall": "Nether-tellistest müür",
  "block.minecraft.nether_bricks": "Nether-tellised",
  "block.minecraft.nether_gold_ore": "Netheri kullamaak",
  "block.minecraft.nether_portal": "Netheri portaal",
  "block.minecraft.nether_quartz_ore": "Netheri kvartsmaak",
  "block.minecraft.nether_sprouts": "Nether-võrsed",
  "block.minecraft.nether_wart": "Nethertüügas",
  "block.minecraft.nether_wart_block": "Nethertüüka plokk",
  "block.minecraft.netherite_block": "Netheriitplokk",
  "block.minecraft.netherrack": "Netherrack",
  "block.minecraft.note_block": "Noodiplokk",
  "block.minecraft.oak_button": "Tammenupp",
  "block.minecraft.oak_door": "Tammest uks",
  "block.minecraft.oak_fence": "Tammest aed",
  "block.minecraft.oak_fence_gate": "Tammest aiavärav",
  "block.minecraft.oak_hanging_sign": "Tammest rippuv silt",
  "block.minecraft.oak_leaves": "Tammelehed",
  "block.minecraft.oak_log": "Tammepalk",
  "block.minecraft.oak_planks": "Tammelauad",
  "block.minecraft.oak_pressure_plate": "Tammest surveplaat",
  "block.minecraft.oak_sapling": "Tammeistik",
  "block.minecraft.oak_shelf": "Tammest riiul",
  "block.minecraft.oak_sign": "Tammest silt",
  "block.minecraft.oak_slab": "Tammeplaat",
  "block.minecraft.oak_stairs": "Tammetrepp",
  "block.minecraft.oak_trapdoor": "Tammeluuk",
  "block.minecraft.oak_wall_hanging_sign": "Tammest seinal rippuv silt",
  "block.minecraft.oak_wall_sign": "Tammest seinasilt",
  "block.minecraft.oak_wood": "Tammepuit",
  "block.minecraft.observer": "Vaatleja",
  "block.minecraft.obsidian": "Obsidiaan",
  "block.minecraft.ochre_froglight": "Ooker konnavalgus",
  "block.minecraft.ominous_banner": "Kurjakuulutav plakat",
  "block.minecraft.open_eyeblossom": "Avatud silmaõis",
  "block.minecraft.orange_banner": "Oranž plakat",
  "block.minecraft.orange_bed": "Oranž voodi",
  "block.minecraft.orange_candle": "Oranž küünal",
  "block.minecraft.orange_candle_cake": "Oranži küünlaga kook",
  "block.minecraft.orange_carpet": "Oranž vaip",
  "block.minecraft.orange_concrete": "Oranž betoon",
  "block.minecraft.orange_concrete_powder": "Oranž betoonipulber",
  "block.minecraft.orange_glazed_terracotta": "Oranž glasuuritud terrakota",
  "block.minecraft.orange_shulker_box": "Oranž šulkerikast",
  "block.minecraft.orange_stained_glass": "Oranži värviga klaas",
  "block.minecraft.orange_stained_glass_pane": "Oranži värviga klaaspaneel",
  "block.minecraft.orange_terracotta": "Oranž terrakota",
  "block.minecraft.orange_tulip": "Oranž tulp",
  "block.minecraft.orange_wool": "Oranž vill",
  "block.minecraft.oxeye_daisy": "Harilik härjasilm",
  "block.minecraft.oxidized_chiseled_copper": "Oksüdeerunud tahutud vask",
  "block.minecraft.oxidized_copper": "Oksüdeerunud vask",
  "block.minecraft.oxidized_copper_bars": "Oksüdeerunud vasktrellid",
  "block.minecraft.oxidized_copper_bulb": "Oksüdeerunud vaskpirn",
  "block.minecraft.oxidized_copper_chain": "Oksüdeerunud vaskkett",
  "block.minecraft.oxidized_copper_chest": "Oksüdeerunud vasest kirst",
  "block.minecraft.oxidized_copper_door": "Oksüdeerunud vaskuks",
  "block.minecraft.oxidized_copper_golem_statue": "Oksüdeerunud vaskgolemi kuju",
  "block.minecraft.oxidized_copper_grate": "Oksüdeerunud vaskvõre",
  "block.minecraft.oxidized_copper_lantern": "Oksüdeerunud vasklatern",
  "block.minecraft.oxidized_copper_trapdoor": "Oksüdeerunud vaskluuk",
  "block.minecraft.oxidized_cut_copper": "Oksüdeerunud lõigatud vask",
  "block.minecraft.oxidized_cut_copper_slab": "Oksüdeerunud lõigatud vasest plaat",
  "block.minecraft.oxidized_cut_copper_stairs": "Oksüdeerunud lõigatud vasest trepp",
  "block.minecraft.oxidized_lightning_rod": "Oksüdeerunud piksevarras",
  "block.minecraft.packed_ice": "Pakitud jää",
  "block.minecraft.packed_mud": "Pakitud muda",
  "block.minecraft.pale_hanging_moss": "Kahvatu rippuv sammal",
  "block.minecraft.pale_moss_block": "Kahvatu sambla plokk",
  "block.minecraft.pale_moss_carpet": "Kahvatu sambla vaip",
  "block.minecraft.pale_oak_button": "Kahvatust tammest nupp",
  "block.minecraft.pale_oak_door": "Kahvatust tammest uks",
  "block.minecraft.pale_oak_fence": "Kahvatust tammest aed",
  "block.minecraft.pale_oak_fence_gate": "Kahvatust tammest aiavärav",
  "block.minecraft.pale_oak_hanging_sign": "Kahvatust tammest rippuv silt",
  "block.minecraft.pale_oak_leaves": "Kahvatu tamme lehed",
  "block.minecraft.pale_oak_log": "Kahvatust tammest palk",
  "block.minecraft.pale_oak_planks": "Kahvatu tamme lauad",
  "block.minecraft.pale_oak_pressure_plate": "Kahvatust tammest surveplaat",
  "block.minecraft.pale_oak_sapling": "Kahvatu tamme istik",
  "block.minecraft.pale_oak_shelf": "Kahvatust tammest riiul",
  "block.minecraft.pale_oak_sign": "Kahvatust tammest silt",
  "block.minecraft.pale_oak_slab": "Kahvatu tamme plaat",
  "block.minecraft.pale_oak_stairs": "Kahvatust tammest trepp",
  "block.minecraft.pale_oak_trapdoor": "Kahvatust tammest luuk",
  "block.minecraft.pale_oak_wall_hanging_sign": "Kahvatust tammest seinal rippuv silt",
  "block.minecraft.pale_oak_wall_sign": "Kahvatust tammest seinasilt",
  "block.minecraft.pale_oak_wood": "Kahvatu tamme puit",
  "block.minecraft.pearlescent_froglight": "Pärlmutriline konnavalgus",
  "block.minecraft.peony": "Pojeng",
  "block.minecraft.petrified_oak_slab": "Kivistunud tammeplaat",
  "block.minecraft.piglin_head": "Piglini pea",
  "block.minecraft.piglin_wall_head": "Piglini seinapea",
  "block.minecraft.pink_banner": "Roosa plakat",
  "block.minecraft.pink_bed": "Roosa voodi",
  "block.minecraft.pink_candle": "Roosa küünal",
  "block.minecraft.pink_candle_cake": "Roosa küünlaga kook",
  "block.minecraft.pink_carpet": "Roosa vaip",
  "block.minecraft.pink_concrete": "Roosa betoon",
  "block.minecraft.pink_concrete_powder": "Roosa betoonipulber",
  "block.minecraft.pink_glazed_terracotta": "Roosa glasuuritud terrakota",
  "block.minecraft.pink_petals": "Roosad kroonlehed",
  "block.minecraft.pink_shulker_box": "Roosa šulkerikast",
  "block.minecraft.pink_stained_glass": "Roosa värviga klaas",
  "block.minecraft.pink_stained_glass_pane": "Roosa värviga klaaspaneel",
  "block.minecraft.pink_terracotta": "Roosa terrakota",
  "block.minecraft.pink_tulip": "Roosa tulp",
  "block.minecraft.pink_wool": "Roosa vill",
  "block.minecraft.piston": "Kolb",
  "block.minecraft.piston_head": "Kolvipea",
  "block.minecraft.pitcher_crop": "Kanntaime saak",
  "block.minecraft.pitcher_plant": "Kanntaim",
  "block.minecraft.player_head": "Mängija pea",
  "block.minecraft.player_head.named": "Mängija %s pea",
  "block.minecraft.player_wall_head": "Mängija seinapea",
  "block.minecraft.podzol": "Leedemuld",
  "block.minecraft.pointed_dripstone": "Suunatud tilkekivi",
  "block.minecraft.polished_andesite": "Lihvitud andesiit",
  "block.minecraft.polished_andesite_slab": "Lihvitud andesiidist plaat",
  "block.minecraft.polished_andesite_stairs": "Lihvitud andesiidist trepp",
  "block.minecraft.polished_basalt": "Lihvitud basalt",
  "block.minecraft.polished_blackstone": "Lihvitud mustkivi",
  "block.minecraft.polished_blackstone_brick_slab": "Lihvitud mustkivi tellisplaat",
  "block.minecraft.polished_blackstone_brick_stairs": "Lihvitud mustkivi tellistrepp",
  "block.minecraft.polished_blackstone_brick_wall": "Lihvitud mustkivi tellistest müür",
  "block.minecraft.polished_blackstone_bricks": "Lihvitud mustkivi tellised",
  "block.minecraft.polished_blackstone_button": "Lihvitud mustkivist nupp",
  "block.minecraft.polished_blackstone_pressure_plate": "Lihvitud mustkivist surveplaat",
  "block.minecraft.polished_blackstone_slab": "Lihvitud mustkivist plaat",
  "block.minecraft.polished_blackstone_stairs": "Lihvitud mustkivist trepp",
  "block.minecraft.polished_blackstone_wall": "Lihvitud mustkivist müür",
  "block.minecraft.polished_deepslate": "Lihvitud sügavkilt",
  "block.minecraft.polished_deepslate_slab": "Lihvitud sügavkildast plaat",
  "block.minecraft.polished_deepslate_stairs": "Lihvitud sügavkildast trepp",
  "block.minecraft.polished_deepslate_wall": "Lihvitud sügavkildast müür",
  "block.minecraft.polished_diorite": "Lihvitud dioriit",
  "block.minecraft.polished_diorite_slab": "Lihvitud dioriidist plaat",
  "block.minecraft.polished_diorite_stairs": "Lihvitud dioriidist trepp",
  "block.minecraft.polished_granite": "Lihvitud graniit",
  "block.minecraft.polished_granite_slab": "Lihvitud graniidist plaat",
  "block.minecraft.polished_granite_stairs": "Lihvitud graniidist trepp",
  "block.minecraft.polished_tuff": "Lihvitud tuff",
  "block.minecraft.polished_tuff_slab": "Lihvitud tufiplaat",
  "block.minecraft.polished_tuff_stairs": "Lihvitud tufitrepp",
  "block.minecraft.polished_tuff_wall": "Lihvitud tufimüür",
  "block.minecraft.poppy": "Magun",
  "block.minecraft.potatoes": "Kartulid",
  "block.minecraft.potted_acacia_sapling": "Akaatsiaistik potis",
  "block.minecraft.potted_allium": "Lauk potis",
  "block.minecraft.potted_azalea_bush": "Asalea potis",
  "block.minecraft.potted_azure_bluet": "Sinine inglisilm potis",
  "block.minecraft.potted_bamboo": "Bambus potis",
  "block.minecraft.potted_birch_sapling": "Kaseistik potis",
  "block.minecraft.potted_blue_orchid": "Sinine orhidee potis",
  "block.minecraft.potted_brown_mushroom": "Pruun seen potis",
  "block.minecraft.potted_cactus": "Kaktus potis",
  "block.minecraft.potted_cherry_sapling": "Kirsipuu istik potis",
  "block.minecraft.potted_closed_eyeblossom": "Suletud silmaõis potis",
  "block.minecraft.potted_cornflower": "Rukkilill potis",
  "block.minecraft.potted_crimson_fungus": "Karmiinpunane seen potis",
  "block.minecraft.potted_crimson_roots": "Karmiinpunased juured potis",
  "block.minecraft.potted_dandelion": "Võilill potis",
  "block.minecraft.potted_dark_oak_sapling": "Tumeda tamme istik potis",
  "block.minecraft.potted_dead_bush": "Surnud põõsas potis",
  "block.minecraft.potted_fern": "Sõnajalg potis",
  "block.minecraft.potted_flowering_azalea_bush": "Õitsev asalea potis",
  "block.minecraft.potted_golden_dandelion": "Kuldne võilill potis",
  "block.minecraft.potted_jungle_sapling": "Džunglipuu istik potis",
  "block.minecraft.potted_lily_of_the_valley": "Maikelluke potis",
  "block.minecraft.potted_mangrove_propagule": "Mangroovi sigipung potis",
  "block.minecraft.potted_oak_sapling": "Tammeistik potis",
  "block.minecraft.potted_open_eyeblossom": "Avatud silmaõis potis",
  "block.minecraft.potted_orange_tulip": "Oranž tulp potis",
  "block.minecraft.potted_oxeye_daisy": "Harilik härjasilm potis",
  "block.minecraft.potted_pale_oak_sapling": "Kahvatu tamme istik potis",
  "block.minecraft.potted_pink_tulip": "Roosa tulp potis",
  "block.minecraft.potted_poppy": "Magun potis",
  "block.minecraft.potted_red_mushroom": "Punane seen potis",
  "block.minecraft.potted_red_tulip": "Punane tulp potis",
  "block.minecraft.potted_spruce_sapling": "Kuuseistik potis",
  "block.minecraft.potted_torchflower": "Tõrvikulill potis",
  "block.minecraft.potted_warped_fungus": "Kentsakas seen potis",
  "block.minecraft.potted_warped_roots": "Kentsakad juured potis",
  "block.minecraft.potted_white_tulip": "Valge tulp potis",
  "block.minecraft.potted_wither_rose": "Witheriroos potis",
  "block.minecraft.powder_snow": "Puuderlumi",
  "block.minecraft.powder_snow_cauldron": "Puuderlume pada",
  "block.minecraft.powered_rail": "Jõurööpad",
  "block.minecraft.prismarine": "Prismariin",
  "block.minecraft.prismarine_brick_slab": "Prismariini tellisplaat",
  "block.minecraft.prismarine_brick_stairs": "Prismariini tellistrepp",
  "block.minecraft.prismarine_bricks": "Prismariinitellised",
  "block.minecraft.prismarine_slab": "Prismariiniplaat",
  "block.minecraft.prismarine_stairs": "Prismariinitrepp",
  "block.minecraft.prismarine_wall": "Prismariinimüür",
  "block.minecraft.pumpkin": "Kõrvits",
  "block.minecraft.pumpkin_stem": "Kõrvitsavars",
  "block.minecraft.purple_banner": "Lilla plakat",
  "block.minecraft.purple_bed": "Lilla voodi",
  "block.minecraft.purple_candle": "Lilla küünal",
  "block.minecraft.purple_candle_cake": "Lilla küünlaga kook",
  "block.minecraft.purple_carpet": "Lilla vaip",
  "block.minecraft.purple_concrete": "Lilla betoon",
  "block.minecraft.purple_concrete_powder": "Lilla betoonipulber",
  "block.minecraft.purple_glazed_terracotta": "Lilla glasuuritud terrakota",
  "block.minecraft.purple_shulker_box": "Lilla šulkerikast",
  "block.minecraft.purple_stained_glass": "Lilla värviga klaas",
  "block.minecraft.purple_stained_glass_pane": "Lilla värviga klaaspaneel",
  "block.minecraft.purple_terracotta": "Lilla terrakota",
  "block.minecraft.purple_wool": "Lilla vill",
  "block.minecraft.purpur_block": "Purpurplokk",
  "block.minecraft.purpur_pillar": "Purpursammas",
  "block.minecraft.purpur_slab": "Purpurplaat",
  "block.minecraft.purpur_stairs": "Purpurtrepp",
  "block.minecraft.quartz_block": "Kvartsplokk",
  "block.minecraft.quartz_bricks": "Kvartstellised",
  "block.minecraft.quartz_pillar": "Kvartssammas",
  "block.minecraft.quartz_slab": "Kvartsplaat",
  "block.minecraft.quartz_stairs": "Kvartstrepp",
  "block.minecraft.rail": "Rööpad",
  "block.minecraft.raw_copper_block": "Toorvase plokk",
  "block.minecraft.raw_gold_block": "Toorkulla plokk",
  "block.minecraft.raw_iron_block": "Toorraua plokk",
  "block.minecraft.red_banner": "Punane plakat",
  "block.minecraft.red_bed": "Punane voodi",
  "block.minecraft.red_candle": "Punane küünal",
  "block.minecraft.red_candle_cake": "Punase küünlaga kook",
  "block.minecraft.red_carpet": "Punane vaip",
  "block.minecraft.red_concrete": "Punane betoon",
  "block.minecraft.red_concrete_powder": "Punane betoonipulber",
  "block.minecraft.red_glazed_terracotta": "Punane glasuuritud terrakota",
  "block.minecraft.red_mushroom": "Punane seen",
  "block.minecraft.red_mushroom_block": "Punane seeneplokk",
  "block.minecraft.red_nether_brick_slab": "Punane nether-tellisplaat",
  "block.minecraft.red_nether_brick_stairs": "Punane nether-tellistrepp",
  "block.minecraft.red_nether_brick_wall": "Punastest nether-tellistest müür",
  "block.minecraft.red_nether_bricks": "Punased nether-tellised",
  "block.minecraft.red_sand": "Punane liiv",
  "block.minecraft.red_sandstone": "Punane liivakivi",
  "block.minecraft.red_sandstone_slab": "Punane liivakiviplaat",
  "block.minecraft.red_sandstone_stairs": "Punane liivakivitrepp",
  "block.minecraft.red_sandstone_wall": "Punasest liivakivist müür",
  "block.minecraft.red_shulker_box": "Punane šulkerikast",
  "block.minecraft.red_stained_glass": "Punase värviga klaas",
  "block.minecraft.red_stained_glass_pane": "Punase värviga klaaspaneel",
  "block.minecraft.red_terracotta": "Punane terrakota",
  "block.minecraft.red_tulip": "Punane tulp",
  "block.minecraft.red_wool": "Punane vill",
  "block.minecraft.redstone_block": "Redstone-plokk",
  "block.minecraft.redstone_lamp": "Redstone-lamp",
  "block.minecraft.redstone_ore": "Redstone-maak",
  "block.minecraft.redstone_torch": "Redstone-tõrvik",
  "block.minecraft.redstone_wall_torch": "Redstone-seinatõrvik",
  "block.minecraft.redstone_wire": "Redstone-juhe",
  "block.minecraft.reinforced_deepslate": "Tugevdatud sügavkilt",
  "block.minecraft.repeater": "Redstone'i järgur",
  "block.minecraft.repeating_command_block": "Kordav käsuplokk",
  "block.minecraft.resin_block": "Vaiguplokk",
  "block.minecraft.resin_brick_slab": "Vaigutellisplaat",
  "block.minecraft.resin_brick_stairs": "Vaigutellistrepp",
  "block.minecraft.resin_brick_wall": "Vaigutellistest müür",
  "block.minecraft.resin_bricks": "Vaigutellised",
  "block.minecraft.resin_clump": "Vaiguklomp",
  "block.minecraft.respawn_anchor": "Taastekkeankur",
  "block.minecraft.rooted_dirt": "Juurtega muld",
  "block.minecraft.rose_bush": "Roosipõõsas",
  "block.minecraft.sand": "Liiv",
  "block.minecraft.sandstone": "Liivakivi",
  "block.minecraft.sandstone_slab": "Liivakiviplaat",
  "block.minecraft.sandstone_stairs": "Liivakivitrepp",
  "block.minecraft.sandstone_wall": "Liivakivimüür",
  "block.minecraft.scaffolding": "Telling",
  "block.minecraft.sculk": "Sculk",
  "block.minecraft.sculk_catalyst": "Sculk-katalüsaator",
  "block.minecraft.sculk_sensor": "Sculk-sensor",
  "block.minecraft.sculk_shrieker": "Sculk-kisendaja",
  "block.minecraft.sculk_vein": "Sculk-veen",
  "block.minecraft.sea_lantern": "Merelatern",
  "block.minecraft.sea_pickle": "Merikurk",
  "block.minecraft.seagrass": "Mererohi",
  "block.minecraft.set_spawn": "Taastekkekoht määratud",
  "block.minecraft.short_dry_grass": "Madal kuiv muru",
  "block.minecraft.short_grass": "Madal muru",
  "block.minecraft.shroomlight": "Seenevalgus",
  "block.minecraft.shulker_box": "Šulkerikast",
  "block.minecraft.skeleton_skull": "Luukere pealuu",
  "block.minecraft.skeleton_wall_skull": "Luukere seinapealuu",
  "block.minecraft.slime_block": "Limaplokk",
  "block.minecraft.small_amethyst_bud": "Väike ametüstipung",
  "block.minecraft.small_dripleaf": "Väike tilkeleht",
  "block.minecraft.smithing_table": "Sepistuslaud",
  "block.minecraft.smoker": "Suitsuahi",
  "block.minecraft.smooth_basalt": "Sile basalt",
  "block.minecraft.smooth_quartz": "Siledast kvartsist plokk",
  "block.minecraft.smooth_quartz_slab": "Siledast kvartsist plaat",
  "block.minecraft.smooth_quartz_stairs": "Siledast kvartsist trepp",
  "block.minecraft.smooth_red_sandstone": "Sile punane liivakivi",
  "block.minecraft.smooth_red_sandstone_slab": "Siledast punasest liivakivist plaat",
  "block.minecraft.smooth_red_sandstone_stairs": "Siledast punasest liivakivist trepp",
  "block.minecraft.smooth_sandstone": "Sile liivakivi",
  "block.minecraft.smooth_sandstone_slab": "Siledast liivakivist plaat",
  "block.minecraft.smooth_sandstone_stairs": "Siledast liivakivist trepp",
  "block.minecraft.smooth_stone": "Sile kivi",
  "block.minecraft.smooth_stone_slab": "Siledast kivist plaat",
  "block.minecraft.sniffer_egg": "Nuuskijamuna",
  "block.minecraft.snow": "Lumi",
  "block.minecraft.snow_block": "Lumeplokk",
  "block.minecraft.soul_campfire": "Hinge lõkketuli",
  "block.minecraft.soul_fire": "Hingetuli",
  "block.minecraft.soul_lantern": "Hingelatern",
  "block.minecraft.soul_sand": "Hingeliiv",
  "block.minecraft.soul_soil": "Hingepinnas",
  "block.minecraft.soul_torch": "Hingetõrvik",
  "block.minecraft.soul_wall_torch": "Hinge seinatõrvik",
  "block.minecraft.spawn.not_valid": "Sul pole kodust voodit ega laetud taastekkeankurit või see oli takistatud",
  "block.minecraft.spawner": "Koletiste tekitaja",
  "block.minecraft.spawner.desc1": "Kasutades sellel sünnimuna:",
  "block.minecraft.spawner.desc2": "Määrab elukatüübi",
  "block.minecraft.sponge": "Käsn",
  "block.minecraft.spore_blossom": "Eoseõis",
  "block.minecraft.spruce_button": "Kuusenupp",
  "block.minecraft.spruce_door": "Kuusest uks",
  "block.minecraft.spruce_fence": "Kuusest aed",
  "block.minecraft.spruce_fence_gate": "Kuusest aiavärav",
  "block.minecraft.spruce_hanging_sign": "Kuusest rippuv silt",
  "block.minecraft.spruce_leaves": "Kuuseokkad",
  "block.minecraft.spruce_log": "Kuusepalk",
  "block.minecraft.spruce_planks": "Kuuselauad",
  "block.minecraft.spruce_pressure_plate": "Kuusest surveplaat",
  "block.minecraft.spruce_sapling": "Kuuseistik",
  "block.minecraft.spruce_shelf": "Kuusest riiul",
  "block.minecraft.spruce_sign": "Kuusest silt",
  "block.minecraft.spruce_slab": "Kuuseplaat",
  "block.minecraft.spruce_stairs": "Kuusetrepp",
  "block.minecraft.spruce_trapdoor": "Kuuseluuk",
  "block.minecraft.spruce_wall_hanging_sign": "Kuusest seinal rippuv silt",
  "block.minecraft.spruce_wall_sign": "Kuusest seinasilt",
  "block.minecraft.spruce_wood": "Kuusepuit",
  "block.minecraft.sticky_piston": "Kleepuv kolb",
  "block.minecraft.stone": "Kivi",
  "block.minecraft.stone_brick_slab": "Kivitellisplaat",
  "block.minecraft.stone_brick_stairs": "Kivitellistrepp",
  "block.minecraft.stone_brick_wall": "Kivitellistest müür",
  "block.minecraft.stone_bricks": "Kivitellised",
  "block.minecraft.stone_button": "Kivinupp",
  "block.minecraft.stone_pressure_plate": "Kivist surveplaat",
  "block.minecraft.stone_slab": "Kiviplaat",
  "block.minecraft.stone_stairs": "Kivitrepp",
  "block.minecraft.stonecutter": "Kivilõikur",
  "block.minecraft.stripped_acacia_log": "Kooritud akaatsiapalk",
  "block.minecraft.stripped_acacia_wood": "Kooritud akaatsiapuit",
  "block.minecraft.stripped_bamboo_block": "Kooritud bambuse plokk",
  "block.minecraft.stripped_birch_log": "Kooritud kasepalk",
  "block.minecraft.stripped_birch_wood": "Kooritud kasepuit",
  "block.minecraft.stripped_cherry_log": "Kooritud kirsipuu palk",
  "block.minecraft.stripped_cherry_wood": "Kooritud kirsipuit",
  "block.minecraft.stripped_crimson_hyphae": "Kooritud karmiinpunased hüüfid",
  "block.minecraft.stripped_crimson_stem": "Kooritud karmiinpunane vars",
  "block.minecraft.stripped_dark_oak_log": "Kooritud tumeda tamme palk",
  "block.minecraft.stripped_dark_oak_wood": "Kooritud tumeda tamme puit",
  "block.minecraft.stripped_jungle_log": "Kooritud džunglipuu palk",
  "block.minecraft.stripped_jungle_wood": "Kooritud džunglipuit",
  "block.minecraft.stripped_mangrove_log": "Kooritud mangroovipalk",
  "block.minecraft.stripped_mangrove_wood": "Kooritud mangroovipuit",
  "block.minecraft.stripped_oak_log": "Kooritud tammepalk",
  "block.minecraft.stripped_oak_wood": "Kooritud tammepuit",
  "block.minecraft.stripped_pale_oak_log": "Kooritud kahvatu tamme palk",
  "block.minecraft.stripped_pale_oak_wood": "Kooritud kahvatu tamme puit",
  "block.minecraft.stripped_spruce_log": "Kooritud kuusepalk",
  "block.minecraft.stripped_spruce_wood": "Kooritud kuusepuit",
  "block.minecraft.stripped_warped_hyphae": "Kooritud kentsakad hüüfid",
  "block.minecraft.stripped_warped_stem": "Kooritud kentsakas vars",
  "block.minecraft.structure_block": "Struktuuriplokk",
  "block.minecraft.structure_void": "Struktuuritühjus",
  "block.minecraft.sugar_cane": "Suhkruroog",
  "block.minecraft.sunflower": "Päevalill",
  "block.minecraft.suspicious_gravel": "Kahtlane kruus",
  "block.minecraft.suspicious_sand": "Kahtlane liiv",
  "block.minecraft.sweet_berry_bush": "Magusate marjade põõsas",
  "block.minecraft.tall_dry_grass": "Kõrge kuiv muru",
  "block.minecraft.tall_grass": "Kõrge muru",
  "block.minecraft.tall_seagrass": "Kõrge mererohi",
  "block.minecraft.target": "Märklaud",
  "block.minecraft.terracotta": "Terrakota",
  "block.minecraft.test_block": "Testplokk",
  "block.minecraft.test_instance_block": "Testeksemplari plokk",
  "block.minecraft.tinted_glass": "Toonitud klaas",
  "block.minecraft.tnt": "Dünamiit",
  "block.minecraft.tnt.disabled": "Dünamiidiplahvatused on keelatud",
  "block.minecraft.torch": "Tõrvik",
  "block.minecraft.torchflower": "Tõrvikulill",
  "block.minecraft.torchflower_crop": "Tõrvikulille saak",
  "block.minecraft.trapped_chest": "Püüniskirst",
  "block.minecraft.trial_spawner": "Katsumuse tekitaja",
  "block.minecraft.tripwire": "Traadilõks",
  "block.minecraft.tripwire_hook": "Traadilõksu konks",
  "block.minecraft.tube_coral": "Torukorall",
  "block.minecraft.tube_coral_block": "Torukoralli plokk",
  "block.minecraft.tube_coral_fan": "Torukoralli lehvik",
  "block.minecraft.tube_coral_wall_fan": "Torukoralli seinalehvik",
  "block.minecraft.tuff": "Tuff",
  "block.minecraft.tuff_brick_slab": "Tufitellisplaat",
  "block.minecraft.tuff_brick_stairs": "Tufitellistrepp",
  "block.minecraft.tuff_brick_wall": "Tufitellistest müür",
  "block.minecraft.tuff_bricks": "Tufitellised",
  "block.minecraft.tuff_slab": "Tufiplaat",
  "block.minecraft.tuff_stairs": "Tufitrepp",
  "block.minecraft.tuff_wall": "Tufimüür",
  "block.minecraft.turtle_egg": "Kilpkonnamuna",
  "block.minecraft.twisting_vines": "Väänduvad väädid",
  "block.minecraft.twisting_vines_plant": "Väänduvate väätide taim",
  "block.minecraft.vault": "Varahoidla",
  "block.minecraft.verdant_froglight": "Haljendav konnavalgus",
  "block.minecraft.vine": "Väädid",
  "block.minecraft.void_air": "Tühjuseõhk",
  "block.minecraft.wall_torch": "Seinatõrvik",
  "block.minecraft.warped_button": "Kentsakas nupp",
  "block.minecraft.warped_door": "Kentsakas uks",
  "block.minecraft.warped_fence": "Kentsakas aed",
  "block.minecraft.warped_fence_gate": "Kentsakas aiavärav",
  "block.minecraft.warped_fungus": "Kentsakas seen",
  "block.minecraft.warped_hanging_sign": "Kentsakas rippuv silt",
  "block.minecraft.warped_hyphae": "Kentsakad hüüfid",
  "block.minecraft.warped_nylium": "Kentsakas netseel",
  "block.minecraft.warped_planks": "Kentsakad lauad",
  "block.minecraft.warped_pressure_plate": "Kentsakas surveplaat",
  "block.minecraft.warped_roots": "Kentsakad juured",
  "block.minecraft.warped_shelf": "Kentsakas riiul",
  "block.minecraft.warped_sign": "Kentsakas silt",
  "block.minecraft.warped_slab": "Kentsakas plaat",
  "block.minecraft.warped_stairs": "Kentsakas trepp",
  "block.minecraft.warped_stem": "Kentsakas vars",
  "block.minecraft.warped_trapdoor": "Kentsakas luuk",
  "block.minecraft.warped_wall_hanging_sign": "Kentsakas seinal rippuv silt",
  "block.minecraft.warped_wall_sign": "Kentsakas seinasilt",
  "block.minecraft.warped_wart_block": "Kentsaka tüüka plokk",
  "block.minecraft.water": "Vesi",
  "block.minecraft.water_cauldron": "Veepada",
  "block.minecraft.waxed_chiseled_copper": "Vahatatud tahutud vask",
  "block.minecraft.waxed_copper_bars": "Vahatatud vaskttrellid",
  "block.minecraft.waxed_copper_block": "Vahatatud vaseplokk",
  "block.minecraft.waxed_copper_bulb": "Vahatatud vaskpirn",
  "block.minecraft.waxed_copper_chain": "Vahatatud vaskkett",
  "block.minecraft.waxed_copper_chest": "Vahatatud vasest kirst",
  "block.minecraft.waxed_copper_door": "Vahatatud vaskuks",
  "block.minecraft.waxed_copper_golem_statue": "Vahatatud vaskgolemi kuju",
  "block.minecraft.waxed_copper_grate": "Vahatatud vaskvõre",
  "block.minecraft.waxed_copper_lantern": "Vahatatud vasklatern",
  "block.minecraft.waxed_copper_trapdoor": "Vahatatud vaskluuk",
  "block.minecraft.waxed_cut_copper": "Vahatatud lõigatud vask",
  "block.minecraft.waxed_cut_copper_slab": "Vahatatud lõigatud vasest plaat",
  "block.minecraft.waxed_cut_copper_stairs": "Vahatatud lõigatud vasest trepp",
  "block.minecraft.waxed_exposed_chiseled_copper": "Vahatatud pleekinud tahutud vask",
  "block.minecraft.waxed_exposed_copper": "Vahatatud pleekinud vask",
  "block.minecraft.waxed_exposed_copper_bars": "Vahatatud pleekinud vasktrellid",
  "block.minecraft.waxed_exposed_copper_bulb": "Vahatatud pleekinud vaskpirn",
  "block.minecraft.waxed_exposed_copper_chain": "Vahatatud pleekinud vaskkett",
  "block.minecraft.waxed_exposed_copper_chest": "Vahatatud pleekinud vasest kirst",
  "block.minecraft.waxed_exposed_copper_door": "Vahatatud pleekinud vaskuks",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Vahatatud pleekinud vaskgolemi kuju",
  "block.minecraft.waxed_exposed_copper_grate": "Vahatatud pleekinud vaskvõre",
  "block.minecraft.waxed_exposed_copper_lantern": "Vahatatud pleekinud vasklatern",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Vahatatud pleekinud vaskluuk",
  "block.minecraft.waxed_exposed_cut_copper": "Vahatatud pleekinud lõigatud vask",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Vahatatud pleekinud lõigatud vasest plaat",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Vahatatud pleekinud lõigatud vasest trepp",
  "block.minecraft.waxed_exposed_lightning_rod": "Vahatatud pleekinud piksevarras",
  "block.minecraft.waxed_lightning_rod": "Vahatatud piksevarras",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Vahatatud oksüdeerunud tahutud vask",
  "block.minecraft.waxed_oxidized_copper": "Vahatatud oksüdeerunud vask",
  "block.minecraft.waxed_oxidized_copper_bars": "Vahatatud oksüdeerunud vasktrellid",
  "block.minecraft.waxed_oxidized_copper_bulb": "Vahatatud oksüdeerunud vaskpirn",
  "block.minecraft.waxed_oxidized_copper_chain": "Vahatatud oksüdeerunud vaskkett",
  "block.minecraft.waxed_oxidized_copper_chest": "Vahatatud oksüdeerunud vasest kirst",
  "block.minecraft.waxed_oxidized_copper_door": "Vahatatud oksüdeerunud vaskuks",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Vahatatud oksüdeerunud vaskgolemi kuju",
  "block.minecraft.waxed_oxidized_copper_grate": "Vahatatud oksüdeerunud vaskvõre",
  "block.minecraft.waxed_oxidized_copper_lantern": "Vahatatud oksüdeerunud vasklatern",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Vahatatud oksüdeerunud vaskluuk",
  "block.minecraft.waxed_oxidized_cut_copper": "Vahatatud oksüdeerunud lõigatud vask",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Vahatatud oksüdeerunud lõigatud vasest plaat",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Vahatatud oksüdeerunud lõigatud vasest trepp",
  "block.minecraft.waxed_oxidized_lightning_rod": "Vahatatud oksüdeerunud piksevarras",
  "block.minecraft.waxed_weathered_chiseled_copper": "Vahatatud kulunud tahutud vask",
  "block.minecraft.waxed_weathered_copper": "Vahatatud kulunud vask",
  "block.minecraft.waxed_weathered_copper_bars": "Vahatatud kulunud vasktrellid",
  "block.minecraft.waxed_weathered_copper_bulb": "Vahatatud kulunud vaskpirn",
  "block.minecraft.waxed_weathered_copper_chain": "Vahatatud kulunud vaskkett",
  "block.minecraft.waxed_weathered_copper_chest": "Vahatatud kulunud vasest kirst",
  "block.minecraft.waxed_weathered_copper_door": "Vahatatud kulunud vaskuks",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Vahatatud kulunud vaskgolemi kuju",
  "block.minecraft.waxed_weathered_copper_grate": "Vahatatud kulunud vaskvõre",
  "block.minecraft.waxed_weathered_copper_lantern": "Vahatatud kulunud vasklatern",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Vahatatud kulunud vaskluuk",
  "block.minecraft.waxed_weathered_cut_copper": "Vahatatud kulunud lõigatud vask",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Vahatatud kulunud lõigatud vasest plaat",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Vahatatud kulunud lõigatud vasest trepp",
  "block.minecraft.waxed_weathered_lightning_rod": "Vahatatud kulunud piksevarras",
  "block.minecraft.weathered_chiseled_copper": "Kulunud tahutud vask",
  "block.minecraft.weathered_copper": "Kulunud vask",
  "block.minecraft.weathered_copper_bars": "Kulunud vasktrellid",
  "block.minecraft.weathered_copper_bulb": "Kulunud vaskpirn",
  "block.minecraft.weathered_copper_chain": "Kulunud vaskkett",
  "block.minecraft.weathered_copper_chest": "Kulunud vasest kirst",
  "block.minecraft.weathered_copper_door": "Kulunud vaskuks",
  "block.minecraft.weathered_copper_golem_statue": "Kulunud vaskgolemi kuju",
  "block.minecraft.weathered_copper_grate": "Kulunud vaskvõre",
  "block.minecraft.weathered_copper_lantern": "Kulunud vasklatern",
  "block.minecraft.weathered_copper_trapdoor": "Kulunud vaskluuk",
  "block.minecraft.weathered_cut_copper": "Kulunud lõigatud vask",
  "block.minecraft.weathered_cut_copper_slab": "Kulunud lõigatud vasest plaat",
  "block.minecraft.weathered_cut_copper_stairs": "Kulunud lõigatud vasest trepp",
  "block.minecraft.weathered_lightning_rod": "Kulunud piksevarras",
  "block.minecraft.weeping_vines": "Nutvad väädid",
  "block.minecraft.weeping_vines_plant": "Nutvate väätide taim",
  "block.minecraft.wet_sponge": "Märg käsn",
  "block.minecraft.wheat": "Nisuvili",
  "block.minecraft.white_banner": "Valge plakat",
  "block.minecraft.white_bed": "Valge voodi",
  "block.minecraft.white_candle": "Valge küünal",
  "block.minecraft.white_candle_cake": "Valge küünlaga kook",
  "block.minecraft.white_carpet": "Valge vaip",
  "block.minecraft.white_concrete": "Valge betoon",
  "block.minecraft.white_concrete_powder": "Valge betoonipulber",
  "block.minecraft.white_glazed_terracotta": "Valge glasuuritud terrakota",
  "block.minecraft.white_shulker_box": "Valge šulkerikast",
  "block.minecraft.white_stained_glass": "Valge värviga klaas",
  "block.minecraft.white_stained_glass_pane": "Valge värviga klaaspaneel",
  "block.minecraft.white_terracotta": "Valge terrakota",
  "block.minecraft.white_tulip": "Valge tulp",
  "block.minecraft.white_wool": "Valge vill",
  "block.minecraft.wildflowers": "Metslilled",
  "block.minecraft.wither_rose": "Witheriroos",
  "block.minecraft.wither_skeleton_skull": "Wither-luukere pealuu",
  "block.minecraft.wither_skeleton_wall_skull": "Wither-luukere seinapealuu",
  "block.minecraft.yellow_banner": "Kollane plakat",
  "block.minecraft.yellow_bed": "Kollane voodi",
  "block.minecraft.yellow_candle": "Kollane küünal",
  "block.minecraft.yellow_candle_cake": "Kollase küünlaga kook",
  "block.minecraft.yellow_carpet": "Kollane vaip",
  "block.minecraft.yellow_concrete": "Kollane betoon",
  "block.minecraft.yellow_concrete_powder": "Kollane betoonipulber",
  "block.minecraft.yellow_glazed_terracotta": "Kollane glasuuritud terrakota",
  "block.minecraft.yellow_shulker_box": "Kollane šulkerikast",
  "block.minecraft.yellow_stained_glass": "Kollase värviga klaas",
  "block.minecraft.yellow_stained_glass_pane": "Kollase värviga klaaspaneel",
  "block.minecraft.yellow_terracotta": "Kollane terrakota",
  "block.minecraft.yellow_wool": "Kollane vill",
  "block.minecraft.zombie_head": "Zombi pea",
  "block.minecraft.zombie_wall_head": "Zombi seinapea",
  "item.minecraft.acacia_boat": "Akaatsiast paat",
  "item.minecraft.acacia_chest_boat": "Kirstuga akaatsiast paat",
  "item.minecraft.allay_spawn_egg": "Krati sünnimuna",
  "item.minecraft.amethyst_shard": "Ametüstikild",
  "item.minecraft.angler_pottery_shard": "Õngitseja potikild",
  "item.minecraft.angler_pottery_sherd": "Õngitseja potikild",
  "item.minecraft.apple": "Õun",
  "item.minecraft.archer_pottery_shard": "Vibulaskja potikild",
  "item.minecraft.archer_pottery_sherd": "Vibulaskja potikild",
  "item.minecraft.armadillo_scute": "Vöölassoomus",
  "item.minecraft.armadillo_spawn_egg": "Vöölase sünnimuna",
  "item.minecraft.armor_stand": "Rüüalus",
  "item.minecraft.arms_up_pottery_shard": "Käed üleval potikild",
  "item.minecraft.arms_up_pottery_sherd": "Käed üleval potikild",
  "item.minecraft.arrow": "Nool",
  "item.minecraft.axolotl_bucket": "Aksolotli ämber",
  "item.minecraft.axolotl_spawn_egg": "Aksolotli sünnimuna",
  "item.minecraft.baked_potato": "Ahjukartul",
  "item.minecraft.bamboo_chest_raft": "Kirstuga bambusest parv",
  "item.minecraft.bamboo_raft": "Bambusest parv",
  "item.minecraft.bat_spawn_egg": "Nahkhiire sünnimuna",
  "item.minecraft.bee_spawn_egg": "Mesilase sünnimuna",
  "item.minecraft.beef": "Toores veiseliha",
  "item.minecraft.beetroot": "Peet",
  "item.minecraft.beetroot_seeds": "Peediseemned",
  "item.minecraft.beetroot_soup": "Peedisupp",
  "item.minecraft.birch_boat": "Kasest paat",
  "item.minecraft.birch_chest_boat": "Kirstuga kasest paat",
  "item.minecraft.black_bundle": "Must komps",
  "item.minecraft.black_dye": "Must värvaine",
  "item.minecraft.black_harness": "Mustad rakmed",
  "item.minecraft.blade_pottery_shard": "Mõõgatera potikild",
  "item.minecraft.blade_pottery_sherd": "Mõõgatera potikild",
  "item.minecraft.blaze_powder": "Lõõmapuuder",
  "item.minecraft.blaze_rod": "Lõõmavarras",
  "item.minecraft.blaze_spawn_egg": "Lõõma sünnimuna",
  "item.minecraft.blue_bundle": "Sinine komps",
  "item.minecraft.blue_dye": "Sinine värvaine",
  "item.minecraft.blue_egg": "Sinine muna",
  "item.minecraft.blue_harness": "Sinised rakmed",
  "item.minecraft.bogged_spawn_egg": "Rabatu sünnimuna",
  "item.minecraft.bolt_armor_trim_smithing_template": "Sepistusmall",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Poldi rüüornament",
  "item.minecraft.bone": "Kont",
  "item.minecraft.bone_meal": "Kondijahu",
  "item.minecraft.book": "Raamat",
  "item.minecraft.bordure_indented_banner_pattern": "Sakkidega poordi plakatimuster",
  "item.minecraft.bow": "Vibu",
  "item.minecraft.bowl": "Kauss",
  "item.minecraft.bread": "Sai",
  "item.minecraft.breeze_rod": "Briisivarras",
  "item.minecraft.breeze_spawn_egg": "Briisi sünnimuna",
  "item.minecraft.brewer_pottery_shard": "Pruulija potikild",
  "item.minecraft.brewer_pottery_sherd": "Pruulija potikild",
  "item.minecraft.brewing_stand": "Pruulimisalus",
  "item.minecraft.brick": "Tellis",
  "item.minecraft.brown_bundle": "Pruun komps",
  "item.minecraft.brown_dye": "Pruun värvaine",
  "item.minecraft.brown_egg": "Pruun muna",
  "item.minecraft.brown_harness": "Pruunid rakmed",
  "item.minecraft.brush": "Hari",
  "item.minecraft.bucket": "Ämber",
  "item.minecraft.bundle": "Komps",
  "item.minecraft.bundle.empty": "Tühi",
  "item.minecraft.bundle.empty.description": "Saab hoida esemete segakuhja",
  "item.minecraft.bundle.full": "Täis",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Põlemise potikild",
  "item.minecraft.burn_pottery_sherd": "Põlemise potikild",
  "item.minecraft.camel_husk_spawn_egg": "Kaamelikuiviku sünnimuna",
  "item.minecraft.camel_spawn_egg": "Kaameli sünnimuna",
  "item.minecraft.carrot": "Porgand",
  "item.minecraft.carrot_on_a_stick": "Porgand pulga otsas",
  "item.minecraft.cat_spawn_egg": "Kassi sünnimuna",
  "item.minecraft.cauldron": "Pada",
  "item.minecraft.cave_spider_spawn_egg": "Koopaämbliku sünnimuna",
  "item.minecraft.chainmail_boots": "Rõngassaapad",
  "item.minecraft.chainmail_chestplate": "Rõngassärk",
  "item.minecraft.chainmail_helmet": "Rõngaskiiver",
  "item.minecraft.chainmail_leggings": "Rõngassäärised",
  "item.minecraft.charcoal": "Puusüsi",
  "item.minecraft.cherry_boat": "Kirsipuidust paat",
  "item.minecraft.cherry_chest_boat": "Kirstuga kirsipuidust paat",
  "item.minecraft.chest_minecart": "Kirstuga kaevanduskäru",
  "item.minecraft.chicken": "Toores kana",
  "item.minecraft.chicken_spawn_egg": "Kana sünnimuna",
  "item.minecraft.chorus_fruit": "Koorivili",
  "item.minecraft.clay_ball": "Savipall",
  "item.minecraft.clock": "Kell",
  "item.minecraft.coal": "Süsi",
  "item.minecraft.coast_armor_trim_smithing_template": "Sepistusmall",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Ranniku rüüornament",
  "item.minecraft.cocoa_beans": "Kakaooad",
  "item.minecraft.cod": "Toores tursk",
  "item.minecraft.cod_bucket": "Tursaämber",
  "item.minecraft.cod_spawn_egg": "Tursa sünnimuna",
  "item.minecraft.command_block_minecart": "Käsuplokiga kaevanduskäru",
  "item.minecraft.compass": "Kompass",
  "item.minecraft.cooked_beef": "Veise praelõik",
  "item.minecraft.cooked_chicken": "Küpsetatud kana",
  "item.minecraft.cooked_cod": "Küpsetatud tursk",
  "item.minecraft.cooked_mutton": "Küpsetatud lambaliha",
  "item.minecraft.cooked_porkchop": "Küpsetatud seakarbonaad",
  "item.minecraft.cooked_rabbit": "Küpsetatud küülik",
  "item.minecraft.cooked_salmon": "Küpsetatud lõhe",
  "item.minecraft.cookie": "Küpsis",
  "item.minecraft.copper_axe": "Vaskkirves",
  "item.minecraft.copper_boots": "Vasksaapad",
  "item.minecraft.copper_chestplate": "Vaskrinnaplaat",
  "item.minecraft.copper_golem_spawn_egg": "Vaskgolemi sünnimuna",
  "item.minecraft.copper_helmet": "Vaskkiiver",
  "item.minecraft.copper_hoe": "Vaskkõblas",
  "item.minecraft.copper_horse_armor": "Hobuse vaskrüü",
  "item.minecraft.copper_ingot": "Vasekang",
  "item.minecraft.copper_leggings": "Vasksäärised",
  "item.minecraft.copper_nautilus_armor": "Laevukese vaskrüü",
  "item.minecraft.copper_nugget": "Vasevaland",
  "item.minecraft.copper_pickaxe": "Vaskkirka",
  "item.minecraft.copper_shovel": "Vasklabidas",
  "item.minecraft.copper_spear": "Vaskoda",
  "item.minecraft.copper_sword": "Vaskmõõk",
  "item.minecraft.cow_spawn_egg": "Lehma sünnimuna",
  "item.minecraft.creaking_spawn_egg": "Kriiksumuse sünnimuna",
  "item.minecraft.creeper_banner_pattern": "Plakatimuster",
  "item.minecraft.creeper_banner_pattern.desc": "Creeperiembleem",
  "item.minecraft.creeper_banner_pattern.new": "Creeperiembleemi plakatimuster",
  "item.minecraft.creeper_spawn_egg": "Creeperi sünnimuna",
  "item.minecraft.crossbow": "Amb",
  "item.minecraft.crossbow.projectile": "Lendkeha:",
  "item.minecraft.crossbow.projectile.multiple": "Lendkeha: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Lendkeha: %s",
  "item.minecraft.cyan_bundle": "Tsüaansinine komps",
  "item.minecraft.cyan_dye": "Tsüaansinine värvaine",
  "item.minecraft.cyan_harness": "Tsüaansinised rakmed",
  "item.minecraft.danger_pottery_shard": "Ohu potikild",
  "item.minecraft.danger_pottery_sherd": "Ohu potikild",
  "item.minecraft.dark_oak_boat": "Tumedast tammest paat",
  "item.minecraft.dark_oak_chest_boat": "Kirstuga tumedast tammest paat",
  "item.minecraft.debug_stick": "Siluripulk",
  "item.minecraft.debug_stick.empty": "%s ei oma atribuute",
  "item.minecraft.debug_stick.select": "\"%s\" (%s) valitud",
  "item.minecraft.debug_stick.update": "\"%s\" väärtus on nüüd %s",
  "item.minecraft.diamond": "Teemant",
  "item.minecraft.diamond_axe": "Teemantkirves",
  "item.minecraft.diamond_boots": "Teemantsaapad",
  "item.minecraft.diamond_chestplate": "Teemantrinnaplaat",
  "item.minecraft.diamond_helmet": "Teemantkiiver",
  "item.minecraft.diamond_hoe": "Teemantkõblas",
  "item.minecraft.diamond_horse_armor": "Hobuse teemantrüü",
  "item.minecraft.diamond_leggings": "Teemantsäärised",
  "item.minecraft.diamond_nautilus_armor": "Laevukese teemantrüü",
  "item.minecraft.diamond_pickaxe": "Teemantkirka",
  "item.minecraft.diamond_shovel": "Teemantlabidas",
  "item.minecraft.diamond_spear": "Teemantoda",
  "item.minecraft.diamond_sword": "Teemantmõõk",
  "item.minecraft.disc_fragment_5": "Plaadikilluke",
  "item.minecraft.disc_fragment_5.desc": "Muusikaplaat - 5",
  "item.minecraft.dolphin_spawn_egg": "Delfiini sünnimuna",
  "item.minecraft.donkey_spawn_egg": "Eesli sünnimuna",
  "item.minecraft.dragon_breath": "Draakoni hingeõhk",
  "item.minecraft.dried_kelp": "Kuivatatud vetikas",
  "item.minecraft.drowned_spawn_egg": "Uppunu sünnimuna",
  "item.minecraft.dune_armor_trim_smithing_template": "Sepistusmall",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Luite rüüornament",
  "item.minecraft.echo_shard": "Kajakild",
  "item.minecraft.egg": "Muna",
  "item.minecraft.elder_guardian_spawn_egg": "Vanemkaitsja sünnimuna",
  "item.minecraft.elytra": "Kattetiivad",
  "item.minecraft.emerald": "Smaragd",
  "item.minecraft.enchanted_book": "Loitsitud raamat",
  "item.minecraft.enchanted_golden_apple": "Loitsitud kuldõun",
  "item.minecraft.end_crystal": "Endikristall",
  "item.minecraft.ender_dragon_spawn_egg": "Enderdraakoni sünnimuna",
  "item.minecraft.ender_eye": "Enderi silm",
  "item.minecraft.ender_pearl": "Enderipärl",
  "item.minecraft.enderman_spawn_egg": "Endermani sünnimuna",
  "item.minecraft.endermite_spawn_egg": "Endermiidi sünnimuna",
  "item.minecraft.evoker_spawn_egg": "Ilmutaja sünnimuna",
  "item.minecraft.experience_bottle": "Loitsimispudel",
  "item.minecraft.explorer_pottery_shard": "Avastaja potikild",
  "item.minecraft.explorer_pottery_sherd": "Avastaja potikild",
  "item.minecraft.eye_armor_trim_smithing_template": "Sepistusmall",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Silma rüüornament",
  "item.minecraft.feather": "Sulg",
  "item.minecraft.fermented_spider_eye": "Käärinud ämblikusilm",
  "item.minecraft.field_masoned_banner_pattern": "Telliste täite plakatimuster",
  "item.minecraft.filled_map": "Kaart",
  "item.minecraft.fire_charge": "Tulelaeng",
  "item.minecraft.firework_rocket": "Ilutulestiku rakett",
  "item.minecraft.firework_rocket.flight": "Lennu kestus:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Ilutulestiku täht",
  "item.minecraft.firework_star.black": "must",
  "item.minecraft.firework_star.blue": "sinine",
  "item.minecraft.firework_star.brown": "pruun",
  "item.minecraft.firework_star.custom_color": "kohandatud",
  "item.minecraft.firework_star.cyan": "tsüaansinine",
  "item.minecraft.firework_star.fade_to": "hajuv",
  "item.minecraft.firework_star.flicker": "sädelev",
  "item.minecraft.firework_star.gray": "hall",
  "item.minecraft.firework_star.green": "roheline",
  "item.minecraft.firework_star.light_blue": "helesinine",
  "item.minecraft.firework_star.light_gray": "helehall",
  "item.minecraft.firework_star.lime": "laimiroheline",
  "item.minecraft.firework_star.magenta": "magentapunane",
  "item.minecraft.firework_star.orange": "oranž",
  "item.minecraft.firework_star.pink": "roosa",
  "item.minecraft.firework_star.purple": "lilla",
  "item.minecraft.firework_star.red": "punane",
  "item.minecraft.firework_star.shape": "Tundmatu kuju",
  "item.minecraft.firework_star.shape.burst": "Lõhkev",
  "item.minecraft.firework_star.shape.creeper": "Creeperi-kujuline",
  "item.minecraft.firework_star.shape.large_ball": "Suur pall",
  "item.minecraft.firework_star.shape.small_ball": "Väike pall",
  "item.minecraft.firework_star.shape.star": "Tähekujuline",
  "item.minecraft.firework_star.trail": "rada",
  "item.minecraft.firework_star.white": "valge",
  "item.minecraft.firework_star.yellow": "kollane",
  "item.minecraft.fishing_rod": "Õng",
  "item.minecraft.flint": "Tulekivi",
  "item.minecraft.flint_and_steel": "Tuleraud",
  "item.minecraft.flow_armor_trim_smithing_template": "Sepistusmall",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Voo rüüornament",
  "item.minecraft.flow_banner_pattern": "Plakatimuster",
  "item.minecraft.flow_banner_pattern.desc": "Voog",
  "item.minecraft.flow_banner_pattern.new": "Voo plakatimuster",
  "item.minecraft.flow_pottery_sherd": "Voo potikild",
  "item.minecraft.flower_banner_pattern": "Plakatimuster",
  "item.minecraft.flower_banner_pattern.desc": "Lille embleem",
  "item.minecraft.flower_banner_pattern.new": "Lille embleemi plakatimuster",
  "item.minecraft.flower_pot": "Lillepott",
  "item.minecraft.fox_spawn_egg": "Rebase sünnimuna",
  "item.minecraft.friend_pottery_shard": "Sõbra potikild",
  "item.minecraft.friend_pottery_sherd": "Sõbra potikild",
  "item.minecraft.frog_spawn_egg": "Konna sünnimuna",
  "item.minecraft.furnace_minecart": "Ahjuga kaevanduskäru",
  "item.minecraft.ghast_spawn_egg": "Ghasti sünnimuna",
  "item.minecraft.ghast_tear": "Ghasti pisar",
  "item.minecraft.glass_bottle": "Klaaspudel",
  "item.minecraft.glistering_melon_slice": "Sätendav arbuusiviil",
  "item.minecraft.globe_banner_pattern": "Plakatimuster",
  "item.minecraft.globe_banner_pattern.desc": "Gloobus",
  "item.minecraft.globe_banner_pattern.new": "Gloobuse plakatimuster",
  "item.minecraft.glow_berries": "Hõõgmarjad",
  "item.minecraft.glow_ink_sac": "Hõõg-tindikott",
  "item.minecraft.glow_item_frame": "Hõõg-esemeraam",
  "item.minecraft.glow_squid_spawn_egg": "Hõõgkalmaari sünnimuna",
  "item.minecraft.glowstone_dust": "Hõõgkivi tolm",
  "item.minecraft.goat_horn": "Kitsesarv",
  "item.minecraft.goat_spawn_egg": "Kitse sünnimuna",
  "item.minecraft.gold_ingot": "Kullakang",
  "item.minecraft.gold_nugget": "Kullavaland",
  "item.minecraft.golden_apple": "Kuldõun",
  "item.minecraft.golden_axe": "Kuldkirves",
  "item.minecraft.golden_boots": "Kuldsaapad",
  "item.minecraft.golden_carrot": "Kuldne porgand",
  "item.minecraft.golden_chestplate": "Kuldrinnaplaat",
  "item.minecraft.golden_helmet": "Kuldkiiver",
  "item.minecraft.golden_hoe": "Kuldkõblas",
  "item.minecraft.golden_horse_armor": "Hobuse kuldrüü",
  "item.minecraft.golden_leggings": "Kuldsäärised",
  "item.minecraft.golden_nautilus_armor": "Laevukese kuldrüü",
  "item.minecraft.golden_pickaxe": "Kuldkirka",
  "item.minecraft.golden_shovel": "Kuldlabidas",
  "item.minecraft.golden_spear": "Kuldoda",
  "item.minecraft.golden_sword": "Kuldmõõk",
  "item.minecraft.gray_bundle": "Hall komps",
  "item.minecraft.gray_dye": "Hall värvaine",
  "item.minecraft.gray_harness": "Hallid rakmed",
  "item.minecraft.green_bundle": "Roheline komps",
  "item.minecraft.green_dye": "Roheline värvaine",
  "item.minecraft.green_harness": "Rohelised rakmed",
  "item.minecraft.guardian_spawn_egg": "Kaitsja sünnimuna",
  "item.minecraft.gunpowder": "Püssirohi",
  "item.minecraft.guster_banner_pattern": "Plakatimuster",
  "item.minecraft.guster_banner_pattern.desc": "Pagija",
  "item.minecraft.guster_banner_pattern.new": "Pagija plakatimuster",
  "item.minecraft.guster_pottery_sherd": "Pagija potikild",
  "item.minecraft.happy_ghast_spawn_egg": "Õnneliku ghasti sünnimuna",
  "item.minecraft.harness": "Rakmed",
  "item.minecraft.heart_of_the_sea": "Mere süda",
  "item.minecraft.heart_pottery_shard": "Südame potikild",
  "item.minecraft.heart_pottery_sherd": "Südame potikild",
  "item.minecraft.heartbreak_pottery_shard": "Murtud südame potikild",
  "item.minecraft.heartbreak_pottery_sherd": "Murtud südame potikild",
  "item.minecraft.hoglin_spawn_egg": "Hoglini sünnimuna",
  "item.minecraft.honey_bottle": "Meepudel",
  "item.minecraft.honeycomb": "Meekärg",
  "item.minecraft.hopper_minecart": "Püüdjaga kaevanduskäru",
  "item.minecraft.horse_spawn_egg": "Hobuse sünnimuna",
  "item.minecraft.host_armor_trim_smithing_template": "Sepistusmall",
  "item.minecraft.host_armor_trim_smithing_template.new": "Võõrustaja rüüornament",
  "item.minecraft.howl_pottery_shard": "Ulgumise potikild",
  "item.minecraft.howl_pottery_sherd": "Ulgumise potikild",
  "item.minecraft.husk_spawn_egg": "Kuiviku sünnimuna",
  "item.minecraft.ink_sac": "Tindikott",
  "item.minecraft.iron_axe": "Raudkirves",
  "item.minecraft.iron_boots": "Raudsaapad",
  "item.minecraft.iron_chestplate": "Raudrinnaplaat",
  "item.minecraft.iron_golem_spawn_egg": "Raudgolemi sünnimuna",
  "item.minecraft.iron_helmet": "Raudkiiver",
  "item.minecraft.iron_hoe": "Raudkõblas",
  "item.minecraft.iron_horse_armor": "Hobuse raudrüü",
  "item.minecraft.iron_ingot": "Rauakang",
  "item.minecraft.iron_leggings": "Raudsäärised",
  "item.minecraft.iron_nautilus_armor": "Laevukese raudrüü",
  "item.minecraft.iron_nugget": "Rauavaland",
  "item.minecraft.iron_pickaxe": "Raudkirka",
  "item.minecraft.iron_shovel": "Raudlabidas",
  "item.minecraft.iron_spear": "Raudoda",
  "item.minecraft.iron_sword": "Raudmõõk",
  "item.minecraft.item_frame": "Esemeraam",
  "item.minecraft.jungle_boat": "Džunglipuidust paat",
  "item.minecraft.jungle_chest_boat": "Kirstuga džunglipuidust paat",
  "item.minecraft.knowledge_book": "Teadmiste raamat",
  "item.minecraft.lapis_lazuli": "Lasuriit",
  "item.minecraft.lava_bucket": "Laavaämber",
  "item.minecraft.lead": "Köis",
  "item.minecraft.leather": "Nahk",
  "item.minecraft.leather_boots": "Nahksaapad",
  "item.minecraft.leather_chestplate": "Nahktuunika",
  "item.minecraft.leather_helmet": "Nahkmüts",
  "item.minecraft.leather_horse_armor": "Hobuse nahkrüü",
  "item.minecraft.leather_leggings": "Nahkpüksid",
  "item.minecraft.light_blue_bundle": "Helesinine komps",
  "item.minecraft.light_blue_dye": "Helesinine värvaine",
  "item.minecraft.light_blue_harness": "Helesinised rakmed",
  "item.minecraft.light_gray_bundle": "Helehall komps",
  "item.minecraft.light_gray_dye": "Helehall värvaine",
  "item.minecraft.light_gray_harness": "Helehallid rakmed",
  "item.minecraft.lime_bundle": "Laimiroheline komps",
  "item.minecraft.lime_dye": "Laimiroheline värvaine",
  "item.minecraft.lime_harness": "Laimirohelised rakmed",
  "item.minecraft.lingering_potion": "Pikaldane võlujook",
  "item.minecraft.lingering_potion.effect.awkward": "Pikaldane kohatu võlujook",
  "item.minecraft.lingering_potion.effect.empty": "Pikaldane meisterdamatu võlujook",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Pikaldane tulekindluse võlujook",
  "item.minecraft.lingering_potion.effect.harming": "Pikaldane kahjustav võlujook",
  "item.minecraft.lingering_potion.effect.healing": "Pikaldane tervendav võlujook",
  "item.minecraft.lingering_potion.effect.infested": "Pikaldane parasiitsuse võlujook",
  "item.minecraft.lingering_potion.effect.invisibility": "Pikaldane nähtamatuse võlujook",
  "item.minecraft.lingering_potion.effect.leaping": "Pikaldane kargamise võlujook",
  "item.minecraft.lingering_potion.effect.levitation": "Pikaldane õhkukerkimise võlujook",
  "item.minecraft.lingering_potion.effect.luck": "Pikaldane õnne võlujook",
  "item.minecraft.lingering_potion.effect.mundane": "Pikaldane ilmalik võlujook",
  "item.minecraft.lingering_potion.effect.night_vision": "Pikaldane öös nägemise võlujook",
  "item.minecraft.lingering_potion.effect.oozing": "Pikaldane immitsuse võlujook",
  "item.minecraft.lingering_potion.effect.poison": "Pikaldane mürgitav võlujook",
  "item.minecraft.lingering_potion.effect.regeneration": "Pikaldane taastav võlujook",
  "item.minecraft.lingering_potion.effect.slow_falling": "Pikaldane aeglase langemise võlujook",
  "item.minecraft.lingering_potion.effect.slowness": "Pikaldane aeglustav võlujook",
  "item.minecraft.lingering_potion.effect.strength": "Pikaldane tugevdav võlujook",
  "item.minecraft.lingering_potion.effect.swiftness": "Pikaldane ruttamise võlujook",
  "item.minecraft.lingering_potion.effect.thick": "Pikaldane tihke võlujook",
  "item.minecraft.lingering_potion.effect.turtle_master": "Pikaldane kilpkonnameistri võlujook",
  "item.minecraft.lingering_potion.effect.water": "Pikaldane veepudel",
  "item.minecraft.lingering_potion.effect.water_breathing": "Pikaldane vees hingamise võlujook",
  "item.minecraft.lingering_potion.effect.weakness": "Pikaldane nõrgestav võlujook",
  "item.minecraft.lingering_potion.effect.weaving": "Pikaldane põimumise võlujook",
  "item.minecraft.lingering_potion.effect.wind_charged": "Pikaldane tuulelaetuse võlujook",
  "item.minecraft.llama_spawn_egg": "Laama sünnimuna",
  "item.minecraft.lodestone_compass": "Teekivi kompass",
  "item.minecraft.mace": "Oganui",
  "item.minecraft.magenta_bundle": "Magentapunane komps",
  "item.minecraft.magenta_dye": "Magentapunane värvaine",
  "item.minecraft.magenta_harness": "Magentapunased rakmed",
  "item.minecraft.magma_cream": "Magmakreem",
  "item.minecraft.magma_cube_spawn_egg": "Magmakuubi sünnimuna",
  "item.minecraft.mangrove_boat": "Mangroovist paat",
  "item.minecraft.mangrove_chest_boat": "Kirstuga mangroovist paat",
  "item.minecraft.map": "Tühi kaart",
  "item.minecraft.melon_seeds": "Arbuusiseemned",
  "item.minecraft.melon_slice": "Arbuusiviil",
  "item.minecraft.milk_bucket": "Piimaämber",
  "item.minecraft.minecart": "Kaevanduskäru",
  "item.minecraft.miner_pottery_shard": "Kaevuri potikild",
  "item.minecraft.miner_pottery_sherd": "Kaevandaja potikild",
  "item.minecraft.mojang_banner_pattern": "Plakatimuster",
  "item.minecraft.mojang_banner_pattern.desc": "Asi",
  "item.minecraft.mojang_banner_pattern.new": "Asja plakatimuster",
  "item.minecraft.mooshroom_spawn_egg": "Mooshroomi sünnimuna",
  "item.minecraft.mourner_pottery_shard": "Leinaja potikild",
  "item.minecraft.mourner_pottery_sherd": "Leinaja potikild",
  "item.minecraft.mule_spawn_egg": "Muula sünnimuna",
  "item.minecraft.mushroom_stew": "Seenehautis",
  "item.minecraft.music_disc_11": "Muusikaplaat",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Muusikaplaat",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Muusikaplaat",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "Muusikaplaat",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Muusikaplaat",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Muusikaplaat",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Muusikaplaat",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "Muusikaplaat",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator (mängutoos)",
  "item.minecraft.music_disc_far": "Muusikaplaat",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Muusikaplaat",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "Muusikaplaat",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Muusikaplaat",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Muusikaplaat",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "Muusikaplaat",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "Muusikaplaat",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "Muusikaplaat",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "Muusikaplaat",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Muusikaplaat",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Muusikaplaat",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "Muusikaplaat",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Muusikaplaat",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Toores lambaliha",
  "item.minecraft.name_tag": "Nimesilt",
  "item.minecraft.nautilus_shell": "Laevukese karp",
  "item.minecraft.nautilus_spawn_egg": "Laevukese sünnimuna",
  "item.minecraft.nether_brick": "Nether-tellis",
  "item.minecraft.nether_star": "Netheritäht",
  "item.minecraft.nether_wart": "Nethertüügas",
  "item.minecraft.netherite_axe": "Netheriitkirves",
  "item.minecraft.netherite_boots": "Netheriitsaapad",
  "item.minecraft.netherite_chestplate": "Netheriitrinnaplaat",
  "item.minecraft.netherite_helmet": "Netheriitkiiver",
  "item.minecraft.netherite_hoe": "Netheriitkõblas",
  "item.minecraft.netherite_horse_armor": "Hobuse netheriitrüü",
  "item.minecraft.netherite_ingot": "Netheriidikang",
  "item.minecraft.netherite_leggings": "Netheriitsäärised",
  "item.minecraft.netherite_nautilus_armor": "Laevukese netheriitrüü",
  "item.minecraft.netherite_pickaxe": "Netheriitkirka",
  "item.minecraft.netherite_scrap": "Netheriidijäägid",
  "item.minecraft.netherite_shovel": "Netheriitlabidas",
  "item.minecraft.netherite_spear": "Netheriitoda",
  "item.minecraft.netherite_sword": "Netheriitmõõk",
  "item.minecraft.netherite_upgrade_smithing_template": "Sepistusmall",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Netheriiditäiendus",
  "item.minecraft.oak_boat": "Tammest paat",
  "item.minecraft.oak_chest_boat": "Kirstuga tammest paat",
  "item.minecraft.ocelot_spawn_egg": "Otseloti sünnimuna",
  "item.minecraft.ominous_bottle": "Kurjakuulutav pudel",
  "item.minecraft.ominous_trial_key": "Kurjakuulutav katsumuse võti",
  "item.minecraft.orange_bundle": "Oranž komps",
  "item.minecraft.orange_dye": "Oranž värvaine",
  "item.minecraft.orange_harness": "Oranžid rakmed",
  "item.minecraft.painting": "Maal",
  "item.minecraft.pale_oak_boat": "Kahvatust tammest paat",
  "item.minecraft.pale_oak_chest_boat": "Kirstuga kahvatust tammest paat",
  "item.minecraft.panda_spawn_egg": "Panda sünnimuna",
  "item.minecraft.paper": "Paber",
  "item.minecraft.parched_spawn_egg": "Tahenenu sünnimuna",
  "item.minecraft.parrot_spawn_egg": "Papagoi sünnimuna",
  "item.minecraft.phantom_membrane": "Fantoomi membraan",
  "item.minecraft.phantom_spawn_egg": "Fantoomi sünnimuna",
  "item.minecraft.pig_spawn_egg": "Sea sünnimuna",
  "item.minecraft.piglin_banner_pattern": "Plakatimuster",
  "item.minecraft.piglin_banner_pattern.desc": "Kärss",
  "item.minecraft.piglin_banner_pattern.new": "Kärsa plakatimuster",
  "item.minecraft.piglin_brute_spawn_egg": "Jõhkra piglini sünnimuna",
  "item.minecraft.piglin_spawn_egg": "Piglini sünnimuna",
  "item.minecraft.pillager_spawn_egg": "Rüüstaja sünnimuna",
  "item.minecraft.pink_bundle": "Roosa komps",
  "item.minecraft.pink_dye": "Roosa värvaine",
  "item.minecraft.pink_harness": "Roosad rakmed",
  "item.minecraft.pitcher_plant": "Kanntaim",
  "item.minecraft.pitcher_pod": "Kanntaime kaun",
  "item.minecraft.plenty_pottery_shard": "Küllaldane potikild",
  "item.minecraft.plenty_pottery_sherd": "Küllaldane potikild",
  "item.minecraft.poisonous_potato": "Mürgine kartul",
  "item.minecraft.polar_bear_spawn_egg": "Jääkaru sünnimuna",
  "item.minecraft.popped_chorus_fruit": "Paisunud koorivili",
  "item.minecraft.porkchop": "Toores seakarbonaad",
  "item.minecraft.potato": "Kartul",
  "item.minecraft.potion": "Võlujook",
  "item.minecraft.potion.effect.awkward": "Kohatu võlujook",
  "item.minecraft.potion.effect.empty": "Meisterdamatu võlujook",
  "item.minecraft.potion.effect.fire_resistance": "Tulekindluse võlujook",
  "item.minecraft.potion.effect.harming": "Kahjustav võlujook",
  "item.minecraft.potion.effect.healing": "Tervendav võlujook",
  "item.minecraft.potion.effect.infested": "Parasiitsuse võlujook",
  "item.minecraft.potion.effect.invisibility": "Nähtamatuse võlujook",
  "item.minecraft.potion.effect.leaping": "Kargamise võlujook",
  "item.minecraft.potion.effect.levitation": "Õhkukerkimise võlujook",
  "item.minecraft.potion.effect.luck": "Õnne võlujook",
  "item.minecraft.potion.effect.mundane": "Ilmalik võlujook",
  "item.minecraft.potion.effect.night_vision": "Öös nägemise võlujook",
  "item.minecraft.potion.effect.oozing": "Immitsuse võlujook",
  "item.minecraft.potion.effect.poison": "Mürgitav võlujook",
  "item.minecraft.potion.effect.regeneration": "Taastav võlujook",
  "item.minecraft.potion.effect.slow_falling": "Aeglase langemise võlujook",
  "item.minecraft.potion.effect.slowness": "Aeglustav võlujook",
  "item.minecraft.potion.effect.strength": "Tugevdav võlujook",
  "item.minecraft.potion.effect.swiftness": "Ruttamise võlujook",
  "item.minecraft.potion.effect.thick": "Tihke võlujook",
  "item.minecraft.potion.effect.turtle_master": "Kilpkonnameistri võlujook",
  "item.minecraft.potion.effect.water": "Veepudel",
  "item.minecraft.potion.effect.water_breathing": "Vees hingamise võlujook",
  "item.minecraft.potion.effect.weakness": "Nõrgestav võlujook",
  "item.minecraft.potion.effect.weaving": "Põimumise võlujook",
  "item.minecraft.potion.effect.wind_charged": "Tuulelaetuse võlujook",
  "item.minecraft.pottery_shard_archer": "Vibulaskja potikild",
  "item.minecraft.pottery_shard_arms_up": "Käed üleval potikild",
  "item.minecraft.pottery_shard_prize": "Auhinna potikild",
  "item.minecraft.pottery_shard_skull": "Pealuu potikild",
  "item.minecraft.powder_snow_bucket": "Puuderlume ämber",
  "item.minecraft.prismarine_crystals": "Prismariinikristallid",
  "item.minecraft.prismarine_shard": "Prismariinikild",
  "item.minecraft.prize_pottery_shard": "Auhinna potikild",
  "item.minecraft.prize_pottery_sherd": "Auhinna potikild",
  "item.minecraft.pufferfish": "Kerakala",
  "item.minecraft.pufferfish_bucket": "Kerakalaämber",
  "item.minecraft.pufferfish_spawn_egg": "Kerakala sünnimuna",
  "item.minecraft.pumpkin_pie": "Kõrvitsapirukas",
  "item.minecraft.pumpkin_seeds": "Kõrvitsaseemned",
  "item.minecraft.purple_bundle": "Lilla komps",
  "item.minecraft.purple_dye": "Lilla värvaine",
  "item.minecraft.purple_harness": "Lillad rakmed",
  "item.minecraft.quartz": "Netheri kvarts",
  "item.minecraft.rabbit": "Toores küülik",
  "item.minecraft.rabbit_foot": "Küüliku jalg",
  "item.minecraft.rabbit_hide": "Küülikunahk",
  "item.minecraft.rabbit_spawn_egg": "Küüliku sünnimuna",
  "item.minecraft.rabbit_stew": "Küülikuhautis",
  "item.minecraft.raiser_armor_trim_smithing_template": "Sepistusmall",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Tõstja rüüornament",
  "item.minecraft.ravager_spawn_egg": "Laastaja sünnimuna",
  "item.minecraft.raw_copper": "Toorvask",
  "item.minecraft.raw_gold": "Toorkuld",
  "item.minecraft.raw_iron": "Toorraud",
  "item.minecraft.recovery_compass": "Taastuskompass",
  "item.minecraft.red_bundle": "Punane komps",
  "item.minecraft.red_dye": "Punane värvaine",
  "item.minecraft.red_harness": "Punased rakmed",
  "item.minecraft.redstone": "Redstone-tolm",
  "item.minecraft.resin_brick": "Vaigutellis",
  "item.minecraft.resin_clump": "Vaiguklomp",
  "item.minecraft.rib_armor_trim_smithing_template": "Sepistusmall",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Ribi rüüornament",
  "item.minecraft.rotten_flesh": "Roiskunud liha",
  "item.minecraft.saddle": "Sadul",
  "item.minecraft.salmon": "Toores lõhe",
  "item.minecraft.salmon_bucket": "Lõheämber",
  "item.minecraft.salmon_spawn_egg": "Lõhe sünnimuna",
  "item.minecraft.scrape_pottery_sherd": "Kraape potikild",
  "item.minecraft.scute": "Soomus",
  "item.minecraft.sentry_armor_trim_smithing_template": "Sepistusmall",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Tunnimehe rüüornament",
  "item.minecraft.shaper_armor_trim_smithing_template": "Sepistusmall",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Voolija rüüornament",
  "item.minecraft.sheaf_pottery_shard": "Vihu potikild",
  "item.minecraft.sheaf_pottery_sherd": "Vihu potikild",
  "item.minecraft.shears": "Käärid",
  "item.minecraft.sheep_spawn_egg": "Lamba sünnimuna",
  "item.minecraft.shelter_pottery_shard": "Varjupaiga potikild",
  "item.minecraft.shelter_pottery_sherd": "Varjupaiga potikild",
  "item.minecraft.shield": "Kilp",
  "item.minecraft.shield.black": "Must kilp",
  "item.minecraft.shield.blue": "Sinine kilp",
  "item.minecraft.shield.brown": "Pruun kilp",
  "item.minecraft.shield.cyan": "Tsüaansinine kilp",
  "item.minecraft.shield.gray": "Hall kilp",
  "item.minecraft.shield.green": "Roheline kilp",
  "item.minecraft.shield.light_blue": "Helesinine kilp",
  "item.minecraft.shield.light_gray": "Helehall kilp",
  "item.minecraft.shield.lime": "Laimiroheline kilp",
  "item.minecraft.shield.magenta": "Magentapunane kilp",
  "item.minecraft.shield.orange": "Oranž kilp",
  "item.minecraft.shield.pink": "Roosa kilp",
  "item.minecraft.shield.purple": "Lilla kilp",
  "item.minecraft.shield.red": "Punane kilp",
  "item.minecraft.shield.white": "Valge kilp",
  "item.minecraft.shield.yellow": "Kollane kilp",
  "item.minecraft.shulker_shell": "Šulkeri kest",
  "item.minecraft.shulker_spawn_egg": "Šulkeri sünnimuna",
  "item.minecraft.sign": "Silt",
  "item.minecraft.silence_armor_trim_smithing_template": "Sepistusmall",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Vaikuse rüüornament",
  "item.minecraft.silverfish_spawn_egg": "Majasoomuka sünnimuna",
  "item.minecraft.skeleton_horse_spawn_egg": "Luukerehobuse sünnimuna",
  "item.minecraft.skeleton_spawn_egg": "Luukere sünnimuna",
  "item.minecraft.skull_banner_pattern": "Plakatimuster",
  "item.minecraft.skull_banner_pattern.desc": "Pealuu embleem",
  "item.minecraft.skull_banner_pattern.new": "Pealuu embleemi plakatimuster",
  "item.minecraft.skull_pottery_shard": "Pealuu potikild",
  "item.minecraft.skull_pottery_sherd": "Pealuu potikild",
  "item.minecraft.slime_ball": "Limapall",
  "item.minecraft.slime_spawn_egg": "Limuse sünnimuna",
  "item.minecraft.smithing_template": "Sepistusmall",
  "item.minecraft.smithing_template.applies_to": "Rakendub:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Lisa kang või kristall",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Rüüle",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Lisa rüü osa",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Kangid ja kristallid",
  "item.minecraft.smithing_template.ingredients": "Koostisosad:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Lisa netheriidikang",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Teemantvarustusele",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Lisa teemantrüü, -mõõk või -tööriist",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Netheriidikang",
  "item.minecraft.smithing_template.upgrade": "Täiendus: ",
  "item.minecraft.sniffer_spawn_egg": "Nuuskija sünnimuna",
  "item.minecraft.snort_pottery_shard": "Nortsatuse potikild",
  "item.minecraft.snort_pottery_sherd": "Nortsatuse potikild",
  "item.minecraft.snout_armor_trim_smithing_template": "Sepistusmall",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Kärsa rüüornament",
  "item.minecraft.snow_golem_spawn_egg": "Lumegolemi sünnimuna",
  "item.minecraft.snowball": "Lumepall",
  "item.minecraft.spectral_arrow": "Spektraalne nool",
  "item.minecraft.spider_eye": "Ämblikusilm",
  "item.minecraft.spider_spawn_egg": "Ämbliku sünnimuna",
  "item.minecraft.spire_armor_trim_smithing_template": "Sepistusmall",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Keeru rüüornament",
  "item.minecraft.splash_potion": "Pritsitav võlujook",
  "item.minecraft.splash_potion.effect.awkward": "Pritsitav kohatu võlujook",
  "item.minecraft.splash_potion.effect.empty": "Pritsitav meisterdamatu võlujook",
  "item.minecraft.splash_potion.effect.fire_resistance": "Pritsitav tulekindluse võlujook",
  "item.minecraft.splash_potion.effect.harming": "Pritsitav kahjustav võlujook",
  "item.minecraft.splash_potion.effect.healing": "Pritsitav tervendav võlujook",
  "item.minecraft.splash_potion.effect.infested": "Pritsitav parasiitsuse võlujook",
  "item.minecraft.splash_potion.effect.invisibility": "Pritsitav nähtamatuse võlujook",
  "item.minecraft.splash_potion.effect.leaping": "Pritsitav kargamise võlujook",
  "item.minecraft.splash_potion.effect.levitation": "Pritsitav õhkukerkimise võlujook",
  "item.minecraft.splash_potion.effect.luck": "Pritsitav õnne võlujook",
  "item.minecraft.splash_potion.effect.mundane": "Pritsitav ilmalik võlujook",
  "item.minecraft.splash_potion.effect.night_vision": "Pritsitav öös nägemise võlujook",
  "item.minecraft.splash_potion.effect.oozing": "Pritsitav immitsuse võlujook",
  "item.minecraft.splash_potion.effect.poison": "Pritsitav mürgitav võlujook",
  "item.minecraft.splash_potion.effect.regeneration": "Pritsitav taastav võlujook",
  "item.minecraft.splash_potion.effect.slow_falling": "Pritsitav aeglase langemise võlujook",
  "item.minecraft.splash_potion.effect.slowness": "Pritsitav aeglustav võlujook",
  "item.minecraft.splash_potion.effect.strength": "Pritsitav tugevdav võlujook",
  "item.minecraft.splash_potion.effect.swiftness": "Pritsitav ruttamise võlujook",
  "item.minecraft.splash_potion.effect.thick": "Pritsitav tihke võlujook",
  "item.minecraft.splash_potion.effect.turtle_master": "Pritsitav kilpkonnameistri võlujook",
  "item.minecraft.splash_potion.effect.water": "Pritsitav veepudel",
  "item.minecraft.splash_potion.effect.water_breathing": "Pritsitav vees hingamise võlujook",
  "item.minecraft.splash_potion.effect.weakness": "Pritsitav nõrgestav võlujook",
  "item.minecraft.splash_potion.effect.weaving": "Pritsitav põimumise võlujook",
  "item.minecraft.splash_potion.effect.wind_charged": "Pritsitav tuulelaetuse võlujook",
  "item.minecraft.spruce_boat": "Kuusest paat",
  "item.minecraft.spruce_chest_boat": "Kirstuga kuusest paat",
  "item.minecraft.spyglass": "Pikksilm",
  "item.minecraft.squid_spawn_egg": "Kalmaari sünnimuna",
  "item.minecraft.stick": "Pulk",
  "item.minecraft.stone_axe": "Kivikirves",
  "item.minecraft.stone_hoe": "Kivikõblas",
  "item.minecraft.stone_pickaxe": "Kivikirka",
  "item.minecraft.stone_shovel": "Kivilabidas",
  "item.minecraft.stone_spear": "Kivioda",
  "item.minecraft.stone_sword": "Kivimõõk",
  "item.minecraft.stray_spawn_egg": "Eksleja sünnimuna",
  "item.minecraft.strider_spawn_egg": "Tatsaja sünnimuna",
  "item.minecraft.string": "Nöör",
  "item.minecraft.sugar": "Suhkur",
  "item.minecraft.suspicious_stew": "Kahtlane hautis",
  "item.minecraft.sweet_berries": "Magusad marjad",
  "item.minecraft.tadpole_bucket": "Kulleseämber",
  "item.minecraft.tadpole_spawn_egg": "Kullese sünnimuna",
  "item.minecraft.tide_armor_trim_smithing_template": "Sepistusmall",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Loode rüüornament",
  "item.minecraft.tipped_arrow": "Mõjuga nool",
  "item.minecraft.tipped_arrow.effect.awkward": "Mõjuga nool",
  "item.minecraft.tipped_arrow.effect.empty": "Meisterdamatu mõjuga nool",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Tulekindluse nool",
  "item.minecraft.tipped_arrow.effect.harming": "Kahjustav nool",
  "item.minecraft.tipped_arrow.effect.healing": "Tervendav nool",
  "item.minecraft.tipped_arrow.effect.infested": "Parasiitsuse nool",
  "item.minecraft.tipped_arrow.effect.invisibility": "Nähtamatuse nool",
  "item.minecraft.tipped_arrow.effect.leaping": "Kargamise nool",
  "item.minecraft.tipped_arrow.effect.levitation": "Õhkukerkimise nool",
  "item.minecraft.tipped_arrow.effect.luck": "Õnne nool",
  "item.minecraft.tipped_arrow.effect.mundane": "Mõjuga nool",
  "item.minecraft.tipped_arrow.effect.night_vision": "Öös nägemise nool",
  "item.minecraft.tipped_arrow.effect.oozing": "Immitsuse nool",
  "item.minecraft.tipped_arrow.effect.poison": "Mürgitav nool",
  "item.minecraft.tipped_arrow.effect.regeneration": "Taastav nool",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Aeglase langemise nool",
  "item.minecraft.tipped_arrow.effect.slowness": "Aeglustav nool",
  "item.minecraft.tipped_arrow.effect.strength": "Tugevdav nool",
  "item.minecraft.tipped_arrow.effect.swiftness": "Ruttamise nool",
  "item.minecraft.tipped_arrow.effect.thick": "Mõjuga nool",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Kilpkonnameistri nool",
  "item.minecraft.tipped_arrow.effect.water": "Plärtsatuse nool",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Vees hingamise nool",
  "item.minecraft.tipped_arrow.effect.weakness": "Nõrgendav nool",
  "item.minecraft.tipped_arrow.effect.weaving": "Põimumise nool",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Tuulelaetuse nool",
  "item.minecraft.tnt_minecart": "Dünamiidiga kaevanduskäru",
  "item.minecraft.torchflower_seeds": "Tõrvikulille seemned",
  "item.minecraft.totem_of_undying": "Ebasurma tootem",
  "item.minecraft.trader_llama_spawn_egg": "Kaupleja laama sünnimuna",
  "item.minecraft.trial_key": "Katsumuse võti",
  "item.minecraft.trident": "Kolmhark",
  "item.minecraft.tropical_fish": "Troopiline kala",
  "item.minecraft.tropical_fish_bucket": "Troopilise kala ämber",
  "item.minecraft.tropical_fish_spawn_egg": "Troopilise kala sünnimuna",
  "item.minecraft.turtle_helmet": "Kilpkonna kilp",
  "item.minecraft.turtle_scute": "Kilpkonnasoomus",
  "item.minecraft.turtle_spawn_egg": "Kilpkonna sünnimuna",
  "item.minecraft.vex_armor_trim_smithing_template": "Sepistusmall",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Pahandaja rüüornament",
  "item.minecraft.vex_spawn_egg": "Pahandaja sünnimuna",
  "item.minecraft.villager_spawn_egg": "Külaelaniku sünnimuna",
  "item.minecraft.vindicator_spawn_egg": "Tasuja sünnimuna",
  "item.minecraft.wandering_trader_spawn_egg": "Uitava kaupleja sünnimuna",
  "item.minecraft.ward_armor_trim_smithing_template": "Sepistusmall",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Eestkostja rüüornament",
  "item.minecraft.warden_spawn_egg": "Valvuri sünnimuna",
  "item.minecraft.warped_fungus_on_a_stick": "Kentsakas seen pulga otsas",
  "item.minecraft.water_bucket": "Veeämber",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Sepistusmall",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Teeleidja rüüornament",
  "item.minecraft.wheat": "Nisu",
  "item.minecraft.wheat_seeds": "Nisuseemned",
  "item.minecraft.white_bundle": "Valge komps",
  "item.minecraft.white_dye": "Valge värvaine",
  "item.minecraft.white_harness": "Valged rakmed",
  "item.minecraft.wild_armor_trim_smithing_template": "Sepistusmall",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Metsik rüüornament",
  "item.minecraft.wind_charge": "Tuulelaeng",
  "item.minecraft.witch_spawn_egg": "Nõia sünnimuna",
  "item.minecraft.wither_skeleton_spawn_egg": "Wither-luukere sünnimuna",
  "item.minecraft.wither_spawn_egg": "Witheri sünnimuna",
  "item.minecraft.wolf_armor": "Hundirüü",
  "item.minecraft.wolf_spawn_egg": "Hundi sünnimuna",
  "item.minecraft.wooden_axe": "Puitkirves",
  "item.minecraft.wooden_hoe": "Puitkõblas",
  "item.minecraft.wooden_pickaxe": "Puitkirka",
  "item.minecraft.wooden_shovel": "Puitlabidas",
  "item.minecraft.wooden_spear": "Puitoda",
  "item.minecraft.wooden_sword": "Puitmõõk",
  "item.minecraft.writable_book": "Raamat ja kirjasulg",
  "item.minecraft.written_book": "Kirjutatud raamat",
  "item.minecraft.yellow_bundle": "Kollane komps",
  "item.minecraft.yellow_dye": "Kollane värvaine",
  "item.minecraft.yellow_harness": "Kollased rakmed",
  "item.minecraft.zoglin_spawn_egg": "Zoglini sünnimuna",
  "item.minecraft.zombie_horse_spawn_egg": "Zombihobuse sünnimuna",
  "item.minecraft.zombie_nautilus_spawn_egg": "Zombilaevukese sünnimuna",
  "item.minecraft.zombie_spawn_egg": "Zombi sünnimuna",
  "item.minecraft.zombie_villager_spawn_egg": "Zombi-külaelaniku sünnimuna",
  "item.minecraft.zombified_piglin_spawn_egg": "Zombistunud piglini sünnimuna"
}
export const et_ee = items; 
